<template>
  <footer class="pos-footer">
    <div class="row">
      <div :class="section.movieDetail ? 'col-lg-12 col-xl-12' : 'col-lg-8 col-xl-9 col-md-8 col-sm-8' ">
        <div class="pos-menus" v-on-clickaway="away" :class="posHiddenMenus ? 'rounded-top-0' : ''" >
          <div class="row h-100 d-flex">
            <div class="col-2 px-0" v-if="posHiddenMenus == false">
              <button
                class="btn-pos-menu border-0"
                v-on:click="showHiddenMenus()"
              >
                <div class="svg-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="6"
                    height="6"
                    viewBox="0 0 6 6"
                  >
                    <circle
                      id="Ellipse_39"
                      data-name="Ellipse 39"
                      cx="3"
                      cy="3"
                      r="3"
                      transform="translate(0)"
                      fill="#969696"
                    />
                  </svg>

                  <span class="mx-1 position-relative" style="top: -1px">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="6"
                      height="6"
                      viewBox="0 0 6 6"
                    >
                      <circle
                        id="Ellipse_39"
                        data-name="Ellipse 39"
                        cx="3"
                        cy="3"
                        r="3"
                        transform="translate(0)"
                        fill="#969696"
                      />
                    </svg>
                  </span>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="6"
                    height="6"
                    viewBox="0 0 6 6"
                  >
                    <circle
                      id="Ellipse_39"
                      data-name="Ellipse 39"
                      cx="3"
                      cy="3"
                      r="3"
                      transform="translate(0)"
                      fill="#969696"
                    />
                  </svg>
                </div>
                <div>{{ $t("more") }}</div>
              </button>
            </div>

            <div class="col-2 px-0" v-if="posHiddenMenus == true">
              <button
                class="btn-pos-menu border-0"
                v-on:click="showHiddenMenus()"
              >
                <div class="svg-container">
                  <img src="@/assets/img/icons/close-x.svg" width="20" alt />
                </div>
                <div>{{ $t("close") }}</div>
              </button>
            </div>


             <!-- Swap -->
 <div
                v-if="section.checkout == true && isMenuActive(12)"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(2)"
              >
                <button class="btn-pos-menu" @click="showRefund('Swap')">
                  <div class="svg-container">
                    <svg
                      height="100px"
                      width="100px"
                      fill="#969696"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      viewBox="0 0 24 24"
                      version="1.1"
                      x="0px"
                      y="0px"
                    >
                      <title>Swap</title>
                      <desc>Created with Sketch.</desc>
                      <g
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <g>
                          <rect x="0" y="0" width="24" height="24"></rect>
                          <path
                            d="M12,22.75 C6.06293894,22.75 1.25,17.9370611 1.25,12 C1.25,6.06293894 6.06293894,1.25 12,1.25 C17.9370611,1.25 22.75,6.06293894 22.75,12 C22.75,17.9370611 17.9370611,22.75 12,22.75 Z M12,21.25 C17.1086339,21.25 21.25,17.1086339 21.25,12 C21.25,6.89136606 17.1086339,2.75 12,2.75 C6.89136606,2.75 2.75,6.89136606 2.75,12 C2.75,17.1086339 6.89136606,21.25 12,21.25 Z"
                            fill="#969696"
                            fill-rule="nonzero"
                          ></path>
                          <path
                            d="M15.75,8.81066017 L15.75,17 C15.75,17.4142136 15.4142136,17.75 15,17.75 C14.5857864,17.75 14.25,17.4142136 14.25,17 L14.25,8.81066017 L12.5303301,10.5303301 C12.2374369,10.8232233 11.7625631,10.8232233 11.4696699,10.5303301 C11.1767767,10.2374369 11.1767767,9.76256313 11.4696699,9.46966991 L14.4696699,6.46966991 C14.7625631,6.1767767 15.2374369,6.1767767 15.5303301,6.46966991 L18.5303301,9.46966991 C18.8232233,9.76256313 18.8232233,10.2374369 18.5303301,10.5303301 C18.2374369,10.8232233 17.7625631,10.8232233 17.4696699,10.5303301 L15.75,8.81066017 Z M8.25,15.1893398 L8.25,7 C8.25,6.58578644 8.58578644,6.25 9,6.25 C9.41421356,6.25 9.75,6.58578644 9.75,7 L9.75,15.1893398 L11.4696699,13.4696699 C11.7625631,13.1767767 12.2374369,13.1767767 12.5303301,13.4696699 C12.8232233,13.7625631 12.8232233,14.2374369 12.5303301,14.5303301 L9.53033009,17.5303301 C9.23743687,17.8232233 8.76256313,17.8232233 8.46966991,17.5303301 L5.46966991,14.5303301 C5.1767767,14.2374369 5.1767767,13.7625631 5.46966991,13.4696699 C5.76256313,13.1767767 6.23743687,13.1767767 6.53033009,13.4696699 L8.25,15.1893398 Z"
                            fill="#969696"
                            fill-rule="nonzero"
                          ></path>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <div>Swap</div>
                </button>
              </div>


            <!-- Cash Card -->
            <div
              v-if="isMenuActive(10)"
              :disabled="disableMenu"
              :class="disableMenu ? 'disable_item' : ''"
              :order="order(1)"
              class="col-2 px-0 border-bottom child"
              :style="'order:' + order(1)"
            >
              <!-- v-b-modal.cashCard -->
              <button
                class="btn-pos-menu"
                @click="
                  () => {
                    posHiddenMenus = false;
                    showRefund('cashCard');
                    showCashCardPos = true;
                  }
                "
              >
                <div class="svg-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="100"
                    height="100"
                    viewBox="0 0 100 100"
                  >
                    <rect width="100%" height="100%" fill="#ffffff"></rect>
                    <g
                      transform="translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)"
                      style="fill: #969696"
                    >
                      <svg
                        fill="#969696"
                        xmlns:dc="http://purl.org/dc/elements/1.1/"
                        xmlns:cc="http://creativecommons.org/ns#"
                        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
                        xmlns:svg="http://www.w3.org/2000/svg"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
                        xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
                        version="1.1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 100 100"
                      >
                        <g transform="translate(0,-952.36218)">
                          <path
                            d="m 85.625011,975.36216 c 4.591382,0 8.374996,3.76154 8.374996,8.31249 l 0,37.37505 c 0,4.5509 -3.783614,8.3125 -8.374996,8.3125 l -71.281204,0 c -4.591488,0 -8.343814,-3.7786 -8.343814,-8.3125 l 0,-37.37505 c 0,-4.53394 3.752326,-8.31249 8.343814,-8.31249 l 71.281204,0 z m 0,4.37499 -71.281204,0 c -2.154614,0 -3.906212,1.78494 -3.906212,3.9375 l 0,1.93752 79.125022,0 0,-1.93752 c 0,-2.13555 -1.783098,-3.9375 -3.937606,-3.9375 z m 3.937606,19.96877 -79.125022,0 0,21.34378 c 0,2.1525 1.751598,3.9375 3.906212,3.9375 l 71.281204,0 c 2.154508,0 3.937606,-1.802 3.937606,-3.9375 l 0,-21.34378 z"
                            style="
                              text-indent: 0;
                              text-transform: none;
                              direction: ltr;
                              block-progression: tb;
                              baseline-shift: baseline;
                              color: #000000;
                              enable-background: accumulate;
                            "
                            fill="#969696"
                            fill-opacity="1"
                            fill-rule="evenodd"
                            stroke="none"
                            marker="none"
                            visibility="visible"
                            display="inline"
                            overflow="visible"
                          ></path>
                          <path
                            d="m 45.792535,1005.9578 a 2.7593622,2.1945051 0 1 1 0,4.3881 l -25.369546,0 a 2.7593622,2.1945051 0 1 1 0,-4.3881 l 25.369546,0 z"
                            style="
                              text-indent: 0;
                              text-transform: none;
                              direction: ltr;
                              block-progression: tb;
                              baseline-shift: baseline;
                              color: #000000;
                              enable-background: accumulate;
                            "
                            fill="#969696"
                            fill-opacity="1"
                            fill-rule="evenodd"
                            stroke="none"
                            marker="none"
                            visibility="visible"
                            display="inline"
                            overflow="visible"
                          ></path>
                          <path
                            d="m 40.222173,1013.8106 a 2.2140577,2.1945051 0 1 1 0,4.3881 l -20.355944,0 a 2.2140577,2.1945051 0 1 1 0,-4.3881 l 20.355944,0 z"
                            style="
                              text-indent: 0;
                              text-transform: none;
                              direction: ltr;
                              block-progression: tb;
                              baseline-shift: baseline;
                              color: #000000;
                              enable-background: accumulate;
                            "
                            fill="#969696"
                            fill-opacity="1"
                            fill-rule="evenodd"
                            stroke="none"
                            marker="none"
                            visibility="visible"
                            display="inline"
                            overflow="visible"
                          ></path>
                        </g>
                      </svg>
                    </g>
                  </svg>
                </div>
                <div>{{ $t("cash") }} {{ $t("card") }}</div>
              </button>
            </div>

            <div v-else class="col-2 px-0 border-left">
              <div
                class="d-flex justify-content-center align-items-center h-100"
              >
                <div class>
                  <div class="d-flex align-items-center">
                    <span class="available-box"></span>
                    <div class="ml-2">{{ $t("available") }}</div>
                  </div>

                  <div class="d-flex align-items-center">
                    <span class="filling-fast-box"></span>
                    <div class="ml-2">{{ $t("fillingfast") }}</div>
                  </div>

                  <div class="d-flex align-items-center">
                    <span class="house-full-box"></span>
                    <div class="ml-2">{{ $t("housefull") }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!--  -->



            <div
              v-if="isMenuActive(1)"
              class="col-2 px-0"
              :style="'order:' + order(1)"
            >
              <button class="btn-pos-menu" v-on:click="showRefund('PosRefund')">
                <div class="svg-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="29.888"
                    height="27.632"
                    viewBox="0 0 29.888 27.632"
                  >
                    <path
                      d="M58.485,84.785A1.169,1.169,0,0,1,60.416,86.1,13.816,13.816,0,1,1,62.4,74.956l.477-.818A1.171,1.171,0,0,1,64.9,75.319l-2.175,3.72a1.17,1.17,0,0,1-1.773.294L57.8,76.6a1.168,1.168,0,0,1,1.529-1.766l.82.71a11.476,11.476,0,1,0-1.66,9.244ZM47.992,69.939h2.23v1.92c2.013.291,3.559,1.4,3.643,3.779l-2.555.088a1.91,1.91,0,0,0-1.088-1.633v2.813c2.186.564,4.013,1.4,4.013,4.047a3.693,3.693,0,0,1-2.306,3.439,6.019,6.019,0,0,1-1.707.41v1.89h-2.23V84.775a4.354,4.354,0,0,1-4.013-4.239l2.485-.246A2.638,2.638,0,0,0,47.992,82.5V78.979c-1.839-.527-3.537-1.453-3.537-3.671,0-2.152,1.688-3.181,3.537-3.454V69.939Zm2.23,9.6v3.033a1.7,1.7,0,0,0,1.458-1.605c0-.755-.679-1.167-1.458-1.428ZM47.992,76.3V74.022c-.582.158-1.105.486-1.105,1.117C46.887,75.7,47.393,76.058,47.992,76.3Z"
                      transform="translate(-35.19 -64.5)"
                      fill="#969696"
                    />
                  </svg>
                </div>
                <div>{{ $tc("refund", 1) }}</div>
              </button>
            </div>

            <div
              v-if="section.checkout == false && isMenuActive(13)"
              class="col-2 px-0 border-bottom child"
              :style="'order:' + order(2)"
            >
            <!-- @click="checkAuthManager('posUserCollection')" -->
              <button
                class="btn-pos-menu"
                @click="OpenFooterMenu('posUserCollection')"

              >
                <div class="svg-container">
                  <svg
                    height="100px"
                    width="100px"
                    fill="#969696"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 512 512"
                    style="enable-background: new 0 0 512 512"
                    xml:space="preserve"
                  >
                    <g>
                      <path
                        d="M273.787,344.624c-2.356-1.039-6.93-2.529-13.721-4.47v-18.139c4.782,0.416,8.073,3.292,9.875,8.628l10.551-2.235   c-2.841-9.251-9.65-14.57-20.426-15.956v-7.484h-7.016v7.484c-14.726,1.802-22.089,8.541-22.089,20.218   c0,4.504,1.386,8.376,4.158,11.616s8.749,5.916,17.931,8.03v20.529c-7.034-0.554-11.555-4.487-13.565-11.798l-11.174,2.599   c3.603,11.399,11.85,17.636,24.739,18.71v9.615h7.016v-9.615c7.45-0.658,13.132-2.893,17.047-6.705   c3.915-3.811,5.873-8.593,5.873-14.345c0-4.054-0.944-7.588-2.833-10.603C278.265,347.69,276.143,345.663,273.787,344.624z    M253.049,339.478c-7.068-0.936-10.603-3.829-10.603-8.68c0-2.876,1.013-5.05,3.04-6.523c2.027-1.473,4.548-2.226,7.562-2.261   V339.478z M268.251,369.987c-2.2,1.871-4.929,2.824-8.186,2.859v-19.906c7.657,1.421,11.486,4.66,11.486,9.719   C271.552,365.673,270.452,368.116,268.251,369.987z"
                      ></path>
                      <path
                        d="M414.427,319.087c-14.413-32.836-34.905-63.974-62.675-95.197c-17.781-20.021-33.792-34.591-50.417-45.865   c-3.77-2.561-7.394-4.94-11.141-6.94c4.82-5.494,10.247-11.635,15.851-17.99c11.73-13.286,24.217-27.428,33.435-38.187   c7.192-8.391,8.534-18.509,3.767-28.498c-3.011-6.336-7.82-10.175-12.472-13.885c-1.927-1.527-3.882-3.082-5.708-4.88   c-3.411-3.368-3.268-3.753-0.414-11.045c2.626-6.122-0.457-10.246-4.238-12.101l-3.596-1.812c-3.082-1.613-6.265-3.282-9.875-4.352   c-26.043-7.706-52.886-8.591-79.842-2.669c-9.818,2.155-17.167,5.651-23.132,11.017c-3.04,2.754-4.01,6.279-2.797,10.218   c0.692,2.258,0.738,3.916,0.446,5.141c-0.141,0.316-0.253,0.642-0.336,0.977c-0.6,1.258-1.618,1.868-2.421,2.16   c-14.641,5.109-24.759,13.186-30.952,24.688c-4.31,8.02-3.339,16.311,2.754,23.332c7.421,8.562,30.81,36.318,44.766,52.872   l5.34,6.33c-6.287,3.561-11.944,7.924-17.285,12.207c-37.973,30.496-69.668,67.927-94.198,111.252   c-17.096,30.167-25.901,56.61-27.756,83.21c-2.069,29.882,7.064,55.155,27.142,75.105c6.464,6.45,13.5,10.731,22.376,13.343   c3.824,1.113,7.677,2.24,11.573,3.111c27.67,6.108,55.84,7.906,82.154,8.933c10.874,0.428,21.705,0.642,32.479,0.642   c23.403,0,46.493-1.013,68.954-3.025c14.727-1.327,32.108-3.296,49.304-7.806c9.047-2.369,17.096-4.838,24.117-10.96   c20.164-17.581,30.624-40.528,31.109-68.226C431.123,367.963,425.943,345.373,414.427,319.087z M316.861,75.978   c2.126,2.083,4.381,3.896,6.621,5.68c0.153,0.122,0.299,0.241,0.451,0.362l-17.661,15.778l10.363-22.05   C316.711,75.824,316.782,75.9,316.861,75.978z M202.741,76.206c0.972-0.345,2.069-0.879,3.179-1.607l11.048,19.887l-20.63-15.67   C198.327,77.872,200.457,77.003,202.741,76.206z M179.495,105.546c-2.954-3.425-3.325-6.35-1.284-10.146   c2.013-3.75,4.562-6.994,7.717-9.811l46.139,35.041c1.056,0.799,2.298,1.199,3.539,1.199c1.37,0,2.74-0.485,3.824-1.441   c2.098-1.798,2.626-4.838,1.284-7.249l-27.516-49.51c0.452-2.586,0.372-5.579-0.525-9.013c4.253-3.539,9.675-5.936,16.939-7.535   c25.016-5.494,49.903-4.681,74.02,2.469c2.697,0.799,5.237,2.155,7.777,3.496c0.571,0.3,1.156,0.599,1.741,0.899   c-0.731,1.876-1.435,3.772-1.878,5.716l-27.776,59.099c-1.17,2.512-0.428,5.508,1.798,7.164c1.042,0.785,2.269,1.17,3.496,1.17   c1.398,0,2.783-0.499,3.896-1.498l39.427-35.219c0.2,0.346,0.4,0.691,0.573,1.056c2.768,5.808,2.083,11.002-2.083,15.869   c-9.19,10.731-21.634,24.816-33.321,38.059c-6.709,7.607-13.167,14.91-18.644,21.172c-0.186-0.047-0.362-0.108-0.55-0.152   c-0.785-0.2-1.584-0.314-2.483-0.428l-0.913-0.128c-0.3-0.043-0.585-0.071-0.885-0.071l-21.222,0.009   c-0.033-0.001-0.065-0.008-0.098-0.009c-0.017,0-0.033,0.003-0.049,0.003c-0.022,0-0.043-0.003-0.065-0.003   c-0.058,0-0.114,0.007-0.172,0.009l-13.784,0.006c-0.571,0-1.156,0.086-1.698,0.257l-2.726,0.785   c-0.752,0.212-1.453,0.415-2.13,0.62l-7.503-8.897C210.376,141.949,186.93,114.122,179.495,105.546z M419.036,389.982   c-0.414,24.588-9.276,44.081-27.085,59.607c-5.123,4.467-11.545,6.407-19.408,8.477c-16.354,4.281-33.136,6.179-47.392,7.463   c-32.308,2.911-65.929,3.682-99.921,2.355c-25.772-1.013-53.314-2.768-80.085-8.676c-3.639-0.799-7.221-1.869-11.645-3.168   c-6.108-1.798-11.53-5.109-16.582-10.146c-17.809-17.709-25.572-39.315-23.717-66.029c1.712-24.788,10.061-49.646,26.243-78.244   c23.803-42.026,54.541-78.33,91.359-107.898c7.221-5.794,14.384-11.245,22.718-14.527c1.113-0.428,2.269-0.742,3.625-1.127   l2.098-0.599l2.777-0.001l-32.688,54.3c-1.67,2.768-0.771,6.35,1.998,8.02c2.768,1.684,6.35,0.785,8.02-1.998l27.171-45.131v17.575   c0,3.225,2.626,5.851,5.851,5.851s5.851-2.626,5.851-5.851V194.37l23.774,43.219c1.07,1.941,3.068,3.04,5.123,3.04   c0.956,0,1.927-0.243,2.811-0.728c2.84-1.555,3.867-5.109,2.312-7.934l-29.981-54.508l11.116-0.005   c0.685,0.1,1.969,0.285,1.998,0.3c6.721,1.584,12.515,5.28,19.393,9.946c15.797,10.717,31.124,24.673,48.248,43.953   c26.942,30.296,46.792,60.435,60.706,92.129C414.541,348.47,419.407,369.49,419.036,389.982z"
                      ></path>
                      <path
                        d="M255.998,262.833c-47.221,0-85.636,38.416-85.636,85.636s38.416,85.636,85.636,85.636s85.636-38.416,85.636-85.636   S303.218,262.833,255.998,262.833z M255.998,422.404c-40.77,0-73.935-33.164-73.935-73.935s33.164-73.935,73.935-73.935   s73.935,33.164,73.935,73.935S296.768,422.404,255.998,422.404z"
                      ></path>
                    </g>
                  </svg>
                </div>
                <div>Collection</div>
              </button>
            </div>

            <!-- <div class="col-2 px-0">
          <button class="btn-pos-menu" v-on:click="showRefund('PosSchedule')">
            <div class="svg-container">
              <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28.933"
              height="35.876"
              viewBox="0 0 28.933 35.876"
              >
              <g id="noun_schedule_2583499" transform="translate(0)">
                <g id="Group_311" data-name="Group 311" transform="translate(0 0)">
                  <g id="Group_310" data-name="Group 310">
                    <g id="Group_308" data-name="Group 308" transform="translate(0 5.506)">
                      <g id="Group_306" data-name="Group 306">
                        <path
                        id="Path_1074"
                        data-name="Path 1074"
                        d="M69.953,108.909a.579.579,0,0,1-.579-.579v-4.48a1.9,1.9,0,0,1,1.893-1.9h5a.578.578,0,0,1,.391,1l-6.315,5.8A.579.579,0,0,1,69.953,108.909Zm1.315-5.8a.74.74,0,0,0-.736.742v3.163l4.251-3.905Z"
                        transform="translate(-53.353 -78.539)"
                        fill="#969696"
                        />
                        <path
                        id="Path_1075"
                        data-name="Path 1075"
                        d="M30.6,51.4H16.713A2.721,2.721,0,0,1,14,48.679V23.754a2.721,2.721,0,0,1,2.713-2.723H31.055a.579.579,0,0,1,0,1.157H16.713a1.563,1.563,0,0,0-1.556,1.565V48.678a1.563,1.563,0,0,0,1.556,1.565H30.375l5.969-5.477V27.451a.579.579,0,0,1,1.157,0v17.57a.578.578,0,0,1-.187.426l-6.323,5.8A.577.577,0,0,1,30.6,51.4Z"
                        transform="translate(-14 -21.031)"
                        fill="#969696"
                        />
                      </g>
                      <rect
                      id="Rectangle_209"
                      data-name="Rectangle 209"
                      width="19.141"
                      height="3.183"
                      rx="1.591"
                      transform="translate(2.128 7.224)"
                      fill="#969696"
                      />
                      <rect
                      id="Rectangle_210"
                      data-name="Rectangle 210"
                      width="19.141"
                      height="3.183"
                      rx="1.591"
                      transform="translate(2.128 11.275)"
                      fill="#969696"
                      />
                      <rect
                      id="Rectangle_211"
                      data-name="Rectangle 211"
                      width="19.141"
                      height="3.183"
                      rx="1.591"
                      transform="translate(2.128 15.325)"
                      fill="#969696"
                      opacity="0.659"
                      />
                      <rect
                      id="Rectangle_212"
                      data-name="Rectangle 212"
                      width="19.141"
                      height="3.183"
                      rx="1.591"
                      transform="translate(2.128 19.376)"
                      fill="#969696"
                      />
                    </g>
                    <g id="Group_309" data-name="Group 309" transform="translate(16.467)">
                      <path
                      id="Path_1079"
                      data-name="Path 1079"
                      d="M77.149,14.514a6.239,6.239,0,1,1,5.827-4.026A6.252,6.252,0,0,1,77.149,14.514Zm0-11.356a5.1,5.1,0,1,0,4.744,6.92h0a5.111,5.111,0,0,0-4.745-6.919Z"
                      transform="translate(-70.916 -2)"
                      fill="#969696"
                      />
                      <path
                      id="Path_1080"
                      data-name="Path 1080"
                      d="M91.037,15.185a.579.579,0,0,1-.579-.579V10.925a.579.579,0,0,1,1.157,0v3.681A.579.579,0,0,1,91.037,15.185Z"
                      transform="translate(-84.804 -7.931)"
                      fill="#969696"
                      />
                      <path
                      id="Path_1081"
                      data-name="Path 1081"
                      d="M93.3,24.227H91.1a.579.579,0,0,1,0-1.157h2.2a.579.579,0,1,1,0,1.157Z"
                      transform="translate(-84.849 -16.974)"
                      fill="#969696"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div>Schedule</div>
        </button>
            </div>-->

            <div
              v-if="isMenuActive(3) && false"
              class="col-2 px-0"
              :style="'order:' + order(3)"
            >
              <button class="btn-pos-menu active">
                <div class="svg-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="34.986"
                    height="15.549"
                    viewBox="0 0 34.986 15.549"
                  >
                    <g id="noun_Ticket_695909" transform="translate(0)">
                      <path
                        id="Path_1073"
                        data-name="Path 1073"
                        d="M39.986,34.859V30H5v4.859H5A2.915,2.915,0,1,1,5,40.69H5v4.859H39.986V40.69a2.916,2.916,0,0,1,0-5.831ZM13.163,45.16h-.389v-.777h.389Zm0-1.555h-.389v-.777h.389Zm0-1.555h-.389v-.777h.389Zm0-1.555h-.389v-.777h.389Zm0-1.555h-.389v-.777h.389Zm0-1.555h-.389v-.777h.389Zm0-1.555h-.389v-.777h.389Zm0-1.555h-.389V33.5h.389Zm0-1.555h-.389v-.777h.389Zm0-1.555h-.389v-.777h.389ZM32.211,45.16h-.389v-.777h.389Zm0-1.555h-.389v-.777h.389Zm0-1.555h-.389v-.777h.389Zm0-1.555h-.389v-.777h.389Zm0-1.555h-.389v-.777h.389Zm0-1.555h-.389v-.777h.389Zm0-1.555h-.389v-.777h.389Zm0-1.555h-.389V33.5h.389Zm0-1.555h-.389v-.777h.389Zm0-1.555h-.389v-.777h.389Z"
                        transform="translate(-5 -30)"
                      />
                    </g>
                  </svg>
                </div>
                <div>{{ $t("book") }}</div>
              </button>
            </div>

            <div
              class="col-2 px-0"
              :style="'order:' + order(3)"
            >
              <button
                class="btn-pos-menu"
                :disabled="true"
                :class="'btnDisable'"
              >
                <div class="svg-container">
                </div>
              </button>
            </div>

            <div
              v-if="isMenuActive(4)"
              class="col-2 px-0"
              :style="'order:' + order(4)"
            >
              <!-- INSTER 'PosOccupancyStatus' IN SHOW REFUND  -->
              <button
                class="btn-pos-menu"
                :disabled="btnDisable"
                :class="btnDisable ? 'btnDisable' : ''"
                v-on:click="onClickFooterBtn('Refresh')"
              >
                <div class="svg-container">
                  <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 20 17">
  <path id="Icon" d="M733-328v-6h4v6h5v-8h3l-10-9-10,9h3v8Z" transform="translate(-725 345)" fill="#969696" fill-rule="evenodd"/>
</svg>

                </div>
                <div>{{ 'Home' }}</div>
              </button>
            </div>
          </div>

          <div v-if="posHiddenMenus" class="pos-menus-hidden">
            <div class="row h-100 hiddenMenuWrapper d-flex">
              <div class="col-2 px-0 pb-2 border-bottom">
                <button
                  class="btn-pos-menu border-0"
                  :disabled="btnDisable"
                  :class="btnDisable ? 'btnDisable' : ''"
                  v-on:click="onClickFooterBtn('Refresh')"
                >
                  <div class="svg-container">
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.5511 0.925995C9.41815 0.917535 6.40535 2.13091 4.15282 4.30831V0.92594C4.15282 0.41455 3.73827 0 3.22688 0C2.71549 0 2.30099 0.41455 2.30099 0.92594V6.4815C2.30088 6.8802 2.55604 7.2342 2.93435 7.36015L8.4899 9.212C8.9757 9.3736 9.5005 9.11075 9.6621 8.625C9.8237 8.1392 9.56085 7.61435 9.07505 7.4528L4.97324 6.088C8.76235 1.96174 15.179 1.68842 19.3053 5.47755C23.4315 9.26665 23.7048 15.6834 19.9157 19.8096C16.1266 23.9358 9.70995 24.2091 5.5837 20.42C3.05397 18.097 1.87158 14.6516 2.44178 11.2648C2.53146 10.7613 2.19607 10.2805 1.69265 10.1908C1.18923 10.101 0.708385 10.4365 0.61865 10.9399C0.617675 10.9454 0.616755 10.9509 0.615885 10.9564C0.505045 11.6195 0.449273 12.2906 0.449219 12.9628C0.45676 19.6076 5.84145 24.9923 12.4861 24.9999C19.1339 25.0179 24.5376 19.6433 24.5556 12.9954C24.5735 6.34765 19.1989 0.943955 12.5511 0.925995Z"
                        fill="#969696"
                      />
                    </svg>
                  </div>
                  {{ $t("refresh") }}
                </button>
              </div>

              <div
                v-if="
                  isMenuActive(5) &&
                  section.checkout == false &&
                  section.seatLayout == false
                "
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(5)"
              >
                <button
                  class="btn-pos-menu"
                  v-on:click="showRefund('UnpaidBooking')"
                >
                  <div class="svg-container">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M16 9H3V10H16V9Z" fill="#969696" />
                      <path d="M16 20H3V21H16V20Z" fill="#969696" />
                      <path d="M26.5 9H20V10H26.5V9Z" fill="#969696" />
                      <path d="M26.5 20H20V21H26.5V20Z" fill="#969696" />
                      <mask id="path-5-inside-1" fill="white">
                        <path
                          d="M29.5 11.5C29.7761 11.5 30 11.2761 30 11V7C30 6.72387 29.7761 6.5 29.5 6.5H0.5C0.223875 6.5 0 6.72387 0 7V11C0 11.2761 0.223875 11.5 0.5 11.5C2.433 11.5 4 13.067 4 15C4 16.933 2.433 18.5 0.5 18.5C0.223875 18.5 0 18.7239 0 19V23C0 23.2761 0.223875 23.5 0.5 23.5H29.5C29.7761 23.5 30 23.2761 30 23V19C30 18.7239 29.7761 18.5 29.5 18.5C27.567 18.5 26 16.933 26 15C26 13.067 27.567 11.5 29.5 11.5ZM25.0292 15.5012C25.2633 17.5896 26.9116 19.2379 29 19.472V22.5H1V19.472C3.46981 19.1952 5.24762 16.9686 4.97081 14.4988C4.73675 12.4104 3.08838 10.7621 1 10.528V7.5H29V10.528C26.5302 10.8048 24.7524 13.0314 25.0292 15.5012Z"
                        />
                      </mask>
                      <path
                        d="M29.5 11.5C29.7761 11.5 30 11.2761 30 11V7C30 6.72387 29.7761 6.5 29.5 6.5H0.5C0.223875 6.5 0 6.72387 0 7V11C0 11.2761 0.223875 11.5 0.5 11.5C2.433 11.5 4 13.067 4 15C4 16.933 2.433 18.5 0.5 18.5C0.223875 18.5 0 18.7239 0 19V23C0 23.2761 0.223875 23.5 0.5 23.5H29.5C29.7761 23.5 30 23.2761 30 23V19C30 18.7239 29.7761 18.5 29.5 18.5C27.567 18.5 26 16.933 26 15C26 13.067 27.567 11.5 29.5 11.5ZM25.0292 15.5012C25.2633 17.5896 26.9116 19.2379 29 19.472V22.5H1V19.472C3.46981 19.1952 5.24762 16.9686 4.97081 14.4988C4.73675 12.4104 3.08838 10.7621 1 10.528V7.5H29V10.528C26.5302 10.8048 24.7524 13.0314 25.0292 15.5012Z"
                        fill="#969696"
                      />
                      <path
                        d="M25.0292 15.5012L16.0852 16.5036L16.0852 16.5036L25.0292 15.5012ZM29 19.472H38V11.4243L30.0024 10.528L29 19.472ZM29 22.5V31.5H38V22.5H29ZM1 22.5H-8V31.5H1V22.5ZM1 19.472L-0.00242875 10.528L-8 11.4244L-8 19.472H1ZM4.97081 14.4988L-3.97319 15.5012L-3.97319 15.5012L4.97081 14.4988ZM1 10.528H-8V18.5756L-0.0024324 19.472L1 10.528ZM1 7.5V-1.5H-8V7.5H1ZM29 7.5H38V-1.5H29V7.5ZM29 10.528L30.0024 19.472L38 18.5756V10.528H29ZM29.5 20.5C34.7467 20.5 39 16.2467 39 11H21C21 6.30556 24.8056 2.5 29.5 2.5V20.5ZM39 11V7H21V11H39ZM39 7C39 1.75331 34.7467 -2.5 29.5 -2.5V15.5C24.8056 15.5 21 11.6944 21 7H39ZM29.5 -2.5H0.5V15.5H29.5V-2.5ZM0.5 -2.5C-4.74669 -2.5 -9 1.75331 -9 7H9C9 11.6944 5.19444 15.5 0.5 15.5V-2.5ZM-9 7V11H9V7H-9ZM-9 11C-9 16.2467 -4.74669 20.5 0.5 20.5V2.5C5.19444 2.5 9 6.30556 9 11H-9ZM0.5 20.5C-2.53756 20.5 -5 18.0376 -5 15H13C13 8.09644 7.40356 2.5 0.5 2.5V20.5ZM-5 15C-5 11.9624 -2.53756 9.5 0.5 9.5V27.5C7.40356 27.5 13 21.9036 13 15H-5ZM0.5 9.5C-4.74669 9.5 -9 13.7533 -9 19H9C9 23.6944 5.19444 27.5 0.5 27.5V9.5ZM-9 19V23H9V19H-9ZM-9 23C-9 28.2467 -4.74669 32.5 0.5 32.5V14.5C5.19444 14.5 9 18.3056 9 23H-9ZM0.5 32.5H29.5V14.5H0.5V32.5ZM29.5 32.5C34.7467 32.5 39 28.2467 39 23H21C21 18.3056 24.8056 14.5 29.5 14.5V32.5ZM39 23V19H21V23H39ZM39 19C39 13.7533 34.7467 9.5 29.5 9.5V27.5C24.8056 27.5 21 23.6944 21 19H39ZM29.5 9.5C32.5376 9.5 35 11.9624 35 15H17C17 21.9036 22.5964 27.5 29.5 27.5V9.5ZM35 15C35 18.0376 32.5376 20.5 29.5 20.5V2.5C22.5964 2.5 17 8.09644 17 15H35ZM16.0852 16.5036C16.7874 22.7687 21.7323 27.7138 27.9976 28.416L30.0024 10.528C32.0909 10.7621 33.7391 12.4104 33.9732 14.4988L16.0852 16.5036ZM20 19.472V22.5H38V19.472H20ZM29 13.5H1V31.5H29V13.5ZM10 22.5V19.472H-8V22.5H10ZM2.00243 28.416C9.41174 27.5856 14.7453 20.906 13.9148 13.4964L-3.97319 15.5012C-4.25002 13.0313 -2.47211 10.8048 -0.00242875 10.528L2.00243 28.416ZM13.9148 13.4964C13.2126 7.23107 8.26749 2.28618 2.00243 1.584L-0.0024324 19.472C-2.09074 19.2379 -3.73912 17.5897 -3.97319 15.5012L13.9148 13.4964ZM10 10.528V7.5H-8V10.528H10ZM1 16.5H29V-1.5H1V16.5ZM20 7.5V10.528H38V7.5H20ZM27.9976 1.584C20.5883 2.41442 15.2547 9.09403 16.0852 16.5036L33.9732 14.4988C34.25 16.9687 32.4721 19.1952 30.0024 19.472L27.9976 1.584Z"
                        fill="#969696"
                        mask="url(#path-5-inside-1)"
                      />
                      <path
                        d="M9.00781 13.4453V15.7866C9.00781 16.1756 8.88574 16.4832 8.6416 16.7095C8.39909 16.9357 8.06706 17.0488 7.64551 17.0488C7.23047 17.0488 6.90088 16.939 6.65674 16.7192C6.4126 16.4995 6.28809 16.1976 6.2832 15.8135V13.4453H7.01562V15.7915C7.01562 16.0243 7.07096 16.1943 7.18164 16.3018C7.29395 16.4076 7.44857 16.4604 7.64551 16.4604C8.05729 16.4604 8.26644 16.244 8.27295 15.811V13.4453H9.00781ZM12.499 17H11.7666L10.3408 14.6611V17H9.6084V13.4453H10.3408L11.769 15.7891V13.4453H12.499V17ZM13.8711 15.7476V17H13.1387V13.4453H14.5254C14.7923 13.4453 15.0267 13.4941 15.2285 13.5918C15.432 13.6895 15.5882 13.8286 15.6973 14.0093C15.8063 14.1883 15.8608 14.3926 15.8608 14.6221C15.8608 14.9704 15.7412 15.2454 15.502 15.4473C15.2643 15.6475 14.9347 15.7476 14.5132 15.7476H13.8711ZM13.8711 15.1543H14.5254C14.7191 15.1543 14.8664 15.1087 14.9673 15.0176C15.0698 14.9264 15.1211 14.7962 15.1211 14.627C15.1211 14.4528 15.0698 14.312 14.9673 14.2046C14.8647 14.0972 14.7231 14.0418 14.5425 14.0386H13.8711V15.1543ZM17.9385 16.2676H16.6543L16.4102 17H15.6313L16.9546 13.4453H17.6333L18.9639 17H18.1851L17.9385 16.2676ZM16.8521 15.6743H17.7407L17.2939 14.3438L16.8521 15.6743ZM20.0747 17H19.3423V13.4453H20.0747V17ZM20.7559 17V13.4453H21.8496C22.1621 13.4453 22.4412 13.5161 22.687 13.6577C22.9344 13.7977 23.1273 13.9979 23.2656 14.2583C23.404 14.5171 23.4731 14.8117 23.4731 15.1421V15.3057C23.4731 15.6361 23.4048 15.9299 23.2681 16.187C23.133 16.4442 22.9417 16.6436 22.6943 16.7852C22.4469 16.9268 22.1678 16.9984 21.8569 17H20.7559ZM21.4883 14.0386V16.4116H21.8423C22.1287 16.4116 22.3477 16.318 22.499 16.1309C22.6504 15.9437 22.7277 15.6759 22.731 15.3276V15.1396C22.731 14.7783 22.6561 14.5049 22.5063 14.3193C22.3566 14.1322 22.1377 14.0386 21.8496 14.0386H21.4883Z"
                        fill="#969696"
                      />
                    </svg>
                  </div>
                  {{ $t("unpaid") }} {{ $t("booking") }}
                </button>
              </div>

              <div
                v-if="
                  isMenuActive(6) &&
                  section.checkout == false &&
                  section.seatLayout == false
                "
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(6)"
              >
                <button
                  class="btn-pos-menu"
                  v-on:click="showRefund('PosPickUpTicket')"
                >
                  <div class="svg-container">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="27"
                      height="27"
                      viewBox="0 0 50.334 40.34"
                    >
                      <g
                        id="noun_box_office_19312"
                        data-name="noun_box office_19312"
                        transform="translate(0 -10.06)"
                      >
                        <g id="Group_314" data-name="Group 314">
                          <g id="Group_313" data-name="Group 313">
                            <path
                              id="Path_1091"
                              data-name="Path 1091"
                              d="M35.117,39.266a4.011,4.011,0,1,1,4.015-4.008A4.013,4.013,0,0,1,35.117,39.266Z"
                              fill="#969696"
                            />
                          </g>
                          <path
                            id="Path_1092"
                            data-name="Path 1092"
                            d="M34.236,50.055l.13-.084h.007l4.945-5.1a.532.532,0,1,1,.765.739l-4.592,4.735H46.259a22.475,22.475,0,0,0-4.772-9.213c-.957-1.157-3.522-2.261-5.292-.594A11.614,11.614,0,0,0,33.4,46.023l-4.509-4.562a1.863,1.863,0,0,0-2.651,2.619L31.9,49.8a1.87,1.87,0,0,0,2.339.254Z"
                            fill="#969696"
                          />
                        </g>
                        <g id="Group_316" data-name="Group 316">
                          <g id="Group_315" data-name="Group 315">
                            <path
                              id="Path_1093"
                              data-name="Path 1093"
                              d="M11.14,39.266a4.011,4.011,0,1,0-4.013-4.008A4.013,4.013,0,0,0,11.14,39.266Z"
                              fill="#969696"
                            />
                          </g>
                          <path
                            id="Path_1094"
                            data-name="Path 1094"
                            d="M12.02,50.055l-.129-.084h-.005l-4.946-5.1a.532.532,0,0,0-.765.739l4.593,4.735H0a22.475,22.475,0,0,1,4.772-9.213c.955-1.157,3.522-2.261,5.292-.594a11.612,11.612,0,0,1,2.793,5.484l4.51-4.562a1.863,1.863,0,0,1,2.65,2.619L14.361,49.8a1.872,1.872,0,0,1-2.341.254Z"
                            fill="#969696"
                          />
                        </g>
                        <path
                          id="Path_1095"
                          data-name="Path 1095"
                          d="M21.349,23.732V33.985h3.62v-6.65H46.714V50.4h3.62V23.732Z"
                          fill="#969696"
                        />
                        <rect
                          id="Rectangle_213"
                          data-name="Rectangle 213"
                          width="3.62"
                          height="13.323"
                          transform="translate(21.349 37.077)"
                          fill="#969696"
                        />
                        <path
                          id="Path_1096"
                          data-name="Path 1096"
                          d="M45.635,13.034V10.06H40.559V11.7H39.113V10.06H26.6v2.975a2.6,2.6,0,0,1,0,5.2v2.973H39.113V19.57h1.446v1.642h5.076V18.24a2.6,2.6,0,0,1,0-5.206ZM40.559,18H39.113V16.354h1.446Zm0-3.165H39.113V13.187h1.446Z"
                          fill="#969696"
                        />
                      </g>
                    </svg>
                  </div>

                  <div>{{ $t("pickup") }} {{ $tc("ticket", 1) }}</div>
                </button>
              </div>

              <!-- <div
                v-if="section.checkout == true && isMenuActive(17)"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(17)"
              >
                <button class="btn-pos-menu" v-b-modal.splitPayments>
                  <div class="svg-container">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M29.7263 5.89913L24.1014 0.274214C23.7358 -0.0914048 23.1414 -0.0914048 22.7758 0.274214L17.1509 5.89913C16.8827 6.16912 16.8021 6.57037 16.9465 6.92099C17.0909 7.27161 17.434 7.50035 17.8127 7.50035H20.6252V10.1066C20.6252 11.0609 20.1583 11.9384 19.3746 12.4578L15.949 14.7415C15.6284 14.9515 15.3134 15.1952 15.0003 15.4784C14.6871 15.1952 14.374 14.9534 14.0572 14.7452L10.6222 12.4559C9.84222 11.9384 9.37535 11.0609 9.37535 10.1066V7.50035H12.1878C12.5666 7.50035 12.9097 7.27161 13.054 6.92099C13.1984 6.57037 13.1178 6.16912 12.8515 5.89913L7.22663 0.274214C6.86102 -0.0914048 6.26665 -0.0914048 5.90103 0.274214L0.276119 5.89913C0.00799783 6.16912 -0.0726259 6.57037 0.0717469 6.92099C0.21612 7.27161 0.559239 7.50035 0.937983 7.50035H3.75044V10.1066C3.75044 12.9378 5.15479 15.5627 7.50601 17.1302L10.941 19.4195C11.7209 19.937 12.1878 20.8145 12.1878 21.7689V29.0625C12.1878 29.58 12.6078 30 13.1253 30H16.8752C17.3927 30 17.8127 29.58 17.8127 29.0625V21.7689C17.8127 20.8145 18.2796 19.937 19.0633 19.4177L22.4945 17.1302C24.8457 15.5627 26.2501 12.9378 26.2501 10.1066V7.50035H29.0625C29.4413 7.50035 29.7844 7.27161 29.9288 6.92099C30.0732 6.57037 29.9925 6.16912 29.7263 5.89913ZM25.3126 5.62538C24.7951 5.62538 24.3751 6.04537 24.3751 6.56287V10.1066C24.3751 12.3078 23.2839 14.3515 21.4539 15.5702L18.0265 17.8558C16.7177 18.7202 15.9377 20.1827 15.9377 21.7689V28.125H14.0628V21.7689C14.0628 20.1827 13.2828 18.7221 11.9778 17.8577L8.54661 15.5702C6.71664 14.3515 5.62541 12.3078 5.62541 10.1066V6.56287C5.62541 6.04537 5.20542 5.62538 4.68792 5.62538H3.20107L6.5629 2.26356L9.92472 5.62538H8.43787C7.92037 5.62538 7.50038 6.04537 7.50038 6.56287V10.1066C7.50038 11.6928 8.28037 13.1534 9.58535 14.0177L13.0222 16.309C13.4478 16.5883 13.8678 16.9558 14.3121 17.4358C14.6646 17.8202 15.3378 17.8202 15.6884 17.4358C16.1309 16.9558 16.5527 16.5883 16.9821 16.3052L20.4096 14.0196C21.7202 13.1553 22.5001 11.6928 22.5001 10.1066V6.56287C22.5001 6.04537 22.0802 5.62538 21.5627 5.62538H20.0758L23.4376 2.26356L26.7995 5.62538H25.3126V5.62538Z"
                        fill="#969696"
                      />
                    </svg>
                  </div>
                  <div>Split Payments</div>
                </button>
              </div> -->

              <!-- Customer Loyalty Points -->
              <!-- <div
                v-if="isMenuActive(9)"
                :order="order(9)"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(9)"
              >
                <button
                  class="btn-pos-menu"
                  @click="showRefund('PosCustomerLoyaltyPoints')"
                >
                  <div class="svg-container">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="100"
                      height="100"
                      viewBox="0 0 100 100"
                    >
                      <rect width="100%" height="100%" fill="#ffffff"></rect>
                      <g
                        transform="translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)"
                        style="fill: #969696"
                      >
                        <svg
                          fill="#969696"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 64 64"
                          x="0px"
                          y="0px"
                        >
                          <title>loyalty</title>
                          <g>
                            <path
                              d="M36,27a9.761,9.761,0,0,0-4,.895A9.761,9.761,0,0,0,28,27,10.011,10.011,0,0,0,18,37c0,9.53,13.026,15.652,13.581,15.908a1,1,0,0,0,.838,0C32.974,52.652,46,46.53,46,37A10.011,10.011,0,0,0,36,27ZM32,50.886C29.831,49.783,20,44.377,20,37a7.9,7.9,0,0,1,11.554-7.1,1.013,1.013,0,0,0,.892,0A7.9,7.9,0,0,1,44,37C44,44.377,34.169,49.783,32,50.886Z"
                            ></path>
                            <polygon
                              points="56 35 56 33 58 33 58 31 56 31 56 29 54 29 54 31 52 31 52 33 54 33 54 35 56 35"
                            ></polygon>
                            <polygon
                              points="31 25 33 25 33 23 35 23 35 21 33 21 33 19 31 19 31 21 29 21 29 23 31 23 31 25"
                            ></polygon>
                            <polygon
                              points="62 41 60 41 60 39 58 39 58 41 56 41 56 43 58 43 58 45 60 45 60 43 62 43 62 41"
                            ></polygon>
                            <polygon
                              points="10 29 8 29 8 31 6 31 6 33 8 33 8 35 10 35 10 33 12 33 12 31 10 31 10 29"
                            ></polygon>
                            <polygon
                              points="6 39 4 39 4 41 2 41 2 43 4 43 4 45 6 45 6 43 8 43 8 41 6 41 6 39"
                            ></polygon>
                            <path
                              d="M58,19a9.01,9.01,0,0,0-8-8.941V5a3,3,0,0,0-3-3H17a3,3,0,0,0-3,3v5.059a9,9,0,0,0,0,17.882V59a3,3,0,0,0,3,3H47a3,3,0,0,0,3-3V27.941A9.01,9.01,0,0,0,58,19Zm-2,0a7,7,0,1,1-7-7A7.008,7.008,0,0,1,56,19ZM22,4H42V5a1,1,0,0,1-1,1H23a1,1,0,0,1-1-1ZM8,19a7,7,0,1,1,7,7A7.008,7.008,0,0,1,8,19ZM47,60H17a1,1,0,0,1-1-1V27.941a9,9,0,0,0,0-17.882V5a1,1,0,0,1,1-1h3V5a3,3,0,0,0,3,3H41a3,3,0,0,0,3-3V4h3a1,1,0,0,1,1,1v5.059a9,9,0,0,0,0,17.882V59A1,1,0,0,1,47,60Z"
                            ></path>
                            <path
                              d="M48,13v1a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h2v2H46v2h2v1h2V24a2,2,0,0,0,2-2V20a2,2,0,0,0-2-2H48V16h4V14H50V13Z"
                            ></path>
                            <path
                              d="M16,25V24a2,2,0,0,0,2-2V20a2,2,0,0,0-2-2H14V16h4V14H16V13H14v1a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h2v2H12v2h2v1Z"
                            ></path>
                            <path
                              d="M33,33H31v1a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h2v2H29v2h2v1h2V44a2,2,0,0,0,2-2V40a2,2,0,0,0-2-2H31V36h4V34H33Z"
                            ></path>
                          </g>
                        </svg>
                      </g>
                    </svg>
                  </div>
                  <div>
                    {{ $t("customer") }} {{ $t("loyalty") }} {{ $t("points") }}
                  </div>
                </button>
              </div> -->
              <!--  -->
              <!-- Multi Currency -->
              <div
                v-if="section.checkout == true && isMenuActive(11)"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(11)"
              >
                <button
                  class="btn-pos-menu"
                  @click="multiCurrencyModal = !multiCurrencyModal"
                >
                  <div class="svg-container">
                    <svg
                      height="100px"
                      width="100px"
                      fill="#000000"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      x="0px"
                      y="0px"
                      viewBox="0 0 96 96"
                      enable-background="new 0 0 96 96"
                      xml:space="preserve"
                    >
                      <path
                        d="M18.954,27.396l-5.912-1.12l-2.413,12.744H4.75v38.545h57.009v3.197h22.343v-8.598h-1.576v-5.598h3.154V57.97h-0.585  l6.38-15.977l-67.576-26.98L18.954,27.396z M14.237,28.03l4.149,0.786l0.751,0.143l0.75,0.142l3.685,0.698l0.751,0.142l0.751,0.143  l35.305,6.688l3.849,0.729l3.847,0.729l4.18,0.792h-2.196h-2.021h-2.023h-8.954h-1.203h-1.406h-1.965l-3.861-0.731l-1.56-0.296  l-1.26-0.238l-22.12-4.19l-0.751-0.143l-0.521-0.099l-0.14,0.737c-0.188,0.995-0.7,1.854-1.4,2.504  c-0.823,0.763-1.912,1.231-3.099,1.232c-0.286,0-0.576-0.027-0.86-0.082l-0.431-0.081l-0.307-0.059l-0.273,1.445H15.12h-0.808  h-2.157L14.237,28.03z M25.641,28.663l0.022-0.056c0.504,0.133,1.021,0.2,1.543,0.2c2.252-0.001,4.272-1.217,5.333-3.153  l20.562,8.21L25.641,28.663z M44.424,39.021h-0.42H21.505h-0.808h-0.807h-0.334c0.134-0.041,0.262-0.097,0.393-0.146  c0.352-0.137,0.688-0.301,1.006-0.498c0.437-0.271,0.837-0.593,1.192-0.964c0.629-0.657,1.126-1.447,1.413-2.344l20.52,3.887  L44.424,39.021z M61.759,73.974v0.764v1.328H6.25V64.222v-2.078V40.521h4.095h0.764h0.763h1.843h0.808h0.808h0.288h0.764h0.763  h2.147h0.808h0.808h21.729h0.962h1.027h3.818h2.477h1.161h0.261h0.547h0.808h2.675h0.101h1.017h0.95h1.964h9.367h2.022h2.021h2.199  v0.878v0.808v0.808v5.821v0.801v3.307v4.031v0.996h-0.188h-0.764h-0.764h-1.964v-8.432h-0.75c-2.529,0-4.587-2.059-4.587-4.588V44.2  h-6.854h-0.775h-0.774h-4.099h-2.267h-0.808h-0.191h-0.616h-0.705h-1.675h-0.016h-0.75h-0.753h-4.228h-0.309h-0.461h-0.768h-0.447  h-1.327H22.428H21.5h-1.004h-4.05h-0.763h-0.417v0.75c0,1.088-0.396,2.075-1.031,2.862c-0.617,0.765-1.465,1.328-2.446,1.574  c-0.277,0.069-0.563,0.109-0.857,0.126c-0.085,0.005-0.166,0.025-0.252,0.025h-0.517h-0.05H9.93v0.46v0.773v0.165v12.455v0.764  v0.764v2.131h0.75c2.529,0,4.587,2.058,4.587,4.586v0.75h34.081h4.031h4.031h2.771v0.525v0.754h1.577V73.974z M70.833,50.992v6.978  h-7.496v7.098h-0.003h-2.023h-1.129v0.356v2.215v0.764v0.764v0.222v0.807v0.691H59.89H49.492h-4.031H41.43H16.721  c-0.341-2.758-2.533-4.95-5.291-5.29v-0.394v-0.763v-0.764v-12.14v-0.544c0.148-0.019,0.287-0.063,0.432-0.091  c0.399-0.08,0.782-0.195,1.149-0.349c0.271-0.113,0.53-0.245,0.78-0.396c0.315-0.189,0.61-0.404,0.886-0.646  c0.355-0.312,0.685-0.65,0.96-1.035c0.572-0.804,0.957-1.75,1.084-2.776h4.809h0.8h0.776H37.62h1.002h1.085h1.008h0.747h0.756h3.412  h0.764h0.764h0.289h1.48h1.086h0.677h0.131h0.131h0.677h0.15h0.151h0.855h6.077h0.747h0.755h5.178  C65.883,48.459,68.075,50.651,70.833,50.992z M61.759,72.165h-0.077v-0.529v-0.034v-0.716v-0.092v-0.808V69.45v-0.764v-0.764v-1.355  h1.363h0.292h1.73h2.023h1.152h0.011h0.656h0.436h0.519h0.13h0.819h0.123h1.396h3.68h0.393v5.598h-0.393h-8.874h-0.143h-1.88h-2.022  H61.759z M77.982,73.761v0.648v1.373v3.48H63.259v-1.697v-0.75v-0.75v-1.045v-0.764v-0.592h0.905h2.687h2.022h2.022h5.117h0.583  h0.167h0.451h0.146h0.153h0.47V73.761z M78.659,66.805v3.239v0.792v1.229v0.1h-0.04h-0.212h-0.502v-0.232v-1.148v-4.031v-0.186  h0.035h0.719V66.805z M78.225,65.067h-0.712h-0.75h-0.08h-0.67h-0.137h-0.201h-1.195h-0.764h-1.383h-0.265h-0.485h-0.75h-0.285  h-0.11h-5.601V59.47h5.996h0.75h0.75h1.68h0.764h0.764h0.473h0.75h0.54h0.21h0.599h0.807h0.367h0.275v2.577v3.021h-0.572H78.225z   M80.236,79.263h-0.754v-5.598h0.754V79.263z M81.025,68.161v4.004h-0.866v-1.834V68.31v-1.742h0.695h0.171V68.161z M81.061,65.067  V64.03V59.47h0.753v2.674v2.022v0.901h-0.36H81.061z M82.602,73.665v5.598h-0.865v-5.598h0.789H82.602z M84.18,60.262v4.806h-0.866  v-2.636v-2.022V59.47h0.375h0.491V60.262z M89.525,42.829L83.48,57.97h-2.384l1.426-7.523l0.241-0.605l-0.118-0.047l1.711-9.028  L89.525,42.829z M81.243,49.133l-0.148,0.782l-0.75,3.961l-0.729,3.847l-0.047,0.247h-0.052H78.71h-0.808h-0.39V43.612v-0.808  v-0.808v-1.98l5.269,0.998L81.243,49.133z M79.686,38.9l-18.89-3.578L31.743,23.722l-0.277,0.697c-0.7,1.754-2.372,2.888-4.26,2.889  c-0.582,0-1.153-0.111-1.7-0.329L24.81,26.7l-0.67,1.679l-3.685-0.698l4.279-10.719L79.686,38.9z"
                      ></path>
                      <path
                        d="M50.771,56.25c-0.054-0.253-0.12-0.501-0.192-0.747c-0.076-0.257-0.166-0.507-0.263-0.755  c-0.335-0.866-0.79-1.671-1.343-2.398c-0.173-0.228-0.354-0.445-0.546-0.656c-0.05-0.056-0.099-0.111-0.149-0.165  c-0.137-0.145-0.278-0.284-0.424-0.42c-0.246-0.23-0.503-0.446-0.771-0.65c-0.234-0.179-0.476-0.347-0.726-0.504  c-0.002-0.001-0.003-0.002-0.005-0.003c-0.224-0.141-0.452-0.275-0.688-0.397c-0.057-0.03-0.116-0.056-0.174-0.085  c-0.03-0.015-0.061-0.028-0.091-0.043c-0.146-0.07-0.286-0.147-0.435-0.21c-0.73-0.31-1.509-0.521-2.316-0.646  c-0.056-0.009-0.111-0.018-0.168-0.025c-0.191-0.026-0.385-0.05-0.58-0.064c-0.073-0.006-0.147-0.007-0.221-0.012  c-0.179-0.01-0.356-0.026-0.538-0.027c-0.003,0-0.006,0-0.009,0c-0.075,0-0.148,0.01-0.224,0.012  c-1.265,0.028-2.473,0.289-3.577,0.752c-0.314,0.133-0.621,0.28-0.918,0.443c-0.313,0.171-0.611,0.361-0.902,0.564  c-1.037,0.724-1.929,1.641-2.622,2.7c-0.139,0.212-0.273,0.427-0.396,0.649c-0.121,0.22-0.227,0.447-0.331,0.676  c-0.505,1.112-0.805,2.333-0.861,3.618c-0.007,0.146-0.022,0.29-0.022,0.438c0,0.124,0.014,0.244,0.019,0.367  c0.011,0.28,0.028,0.559,0.062,0.832c0.122,0.999,0.395,1.951,0.793,2.836c0.131,0.289,0.274,0.57,0.432,0.845  c0.172,0.301,0.361,0.591,0.563,0.87c1.791,2.48,4.699,4.104,7.985,4.104c1.966,0,3.794-0.585,5.333-1.58  c0.291-0.188,0.572-0.388,0.841-0.604c0.028-0.023,0.061-0.043,0.089-0.066c0.215-0.178,0.418-0.366,0.617-0.562  c0.001,0,0.001-0.001,0.002-0.001c0.191-0.188,0.372-0.385,0.548-0.587c0.813-0.935,1.45-2.023,1.867-3.217  c0.083-0.236,0.155-0.476,0.22-0.72c0.063-0.239,0.121-0.479,0.167-0.726c0.001-0.005,0.001-0.01,0.002-0.015  c0.062-0.337,0.104-0.681,0.131-1.028c0.019-0.248,0.038-0.495,0.038-0.748c0-0.092-0.012-0.182-0.014-0.272  C50.956,57.416,50.892,56.823,50.771,56.25z M49.438,59.186c-0.012,0.106-0.033,0.209-0.049,0.314  c-0.029,0.207-0.063,0.413-0.108,0.614c-0.01,0.046-0.023,0.091-0.035,0.136c-0.059,0.246-0.128,0.488-0.208,0.725  c-0.011,0.032-0.024,0.064-0.035,0.097c-0.414,1.167-1.073,2.219-1.926,3.083c-0.194,0.197-0.398,0.386-0.611,0.563  c-0.109,0.091-0.227,0.173-0.34,0.258c-0.121,0.091-0.24,0.184-0.366,0.268c-0.173,0.116-0.353,0.223-0.534,0.325  c-0.374,0.211-0.767,0.39-1.172,0.542c-0.911,0.342-1.893,0.537-2.921,0.537c-2.142,0-4.09-0.816-5.57-2.146  c-0.322-0.29-0.627-0.599-0.901-0.935c-0.227-0.278-0.431-0.575-0.62-0.881c-0.481-0.773-0.84-1.628-1.048-2.541  c-0.064-0.284-0.116-0.573-0.15-0.867c-0.032-0.273-0.051-0.55-0.056-0.83c-0.001-0.052-0.008-0.102-0.008-0.154  c0-1.251,0.284-2.434,0.778-3.5c0.106-0.229,0.222-0.452,0.347-0.669c0.128-0.221,0.265-0.436,0.412-0.644  c0.309-0.436,0.656-0.84,1.04-1.208c0.239-0.229,0.494-0.442,0.76-0.643c0.251-0.19,0.513-0.366,0.785-0.526  c1.193-0.706,2.573-1.123,4.05-1.155c0.062-0.001,0.12-0.009,0.182-0.009c0.079,0,0.155,0.01,0.234,0.012  c0.111,0.003,0.223,0.01,0.333,0.017c0.163,0.012,0.325,0.025,0.485,0.046c0.093,0.012,0.185,0.027,0.276,0.042  c0.219,0.035,0.434,0.078,0.646,0.13c0.546,0.133,1.069,0.318,1.567,0.554c0.238,0.111,0.469,0.233,0.694,0.367  c0.072,0.043,0.145,0.086,0.215,0.131c0.118,0.074,0.235,0.15,0.35,0.231c0.039,0.027,0.076,0.057,0.114,0.085  c0.292,0.214,0.57,0.443,0.832,0.692c0.686,0.651,1.259,1.417,1.692,2.267c0.004,0.008,0.007,0.016,0.011,0.023  c0.137,0.269,0.257,0.546,0.364,0.831c0.054,0.145,0.113,0.287,0.16,0.436c0.036,0.115,0.061,0.235,0.091,0.353  c0.182,0.684,0.288,1.397,0.288,2.138C49.486,58.595,49.469,58.892,49.438,59.186z"
                      ></path>
                      <path
                        d="M45.434,58.729c-0.142-0.326-0.34-0.6-0.593-0.803c-0.201-0.162-0.437-0.277-0.697-0.349  c-0.188-0.052-0.386-0.088-0.602-0.088h-0.146H42.33h-0.448v-0.003v-0.176v-0.256v-0.552v-0.211v-0.765v-0.49V54.19h0.961h1.179  h0.427h0.067h0.27h0.247v-0.548V53.44v-0.556V52.69h-0.485h-0.241h-0.34h-1.008h-1.076V51.8v-0.412h-0.434h-0.316h-0.75v1.303  h-1.245c-0.483,0-0.91,0.081-1.267,0.241c-0.35,0.157-0.637,0.377-0.854,0.658c-0.004,0.006-0.007,0.012-0.011,0.018  c-0.178,0.235-0.303,0.497-0.386,0.794c-0.005,0.019-0.014,0.034-0.019,0.053c-0.027,0.105-0.043,0.223-0.061,0.337  c-0.019,0.119-0.032,0.242-0.041,0.371c-0.008,0.114-0.019,0.226-0.019,0.347v0.453v0.209c0,0.154,0.011,0.3,0.023,0.443  c0.02,0.217,0.049,0.425,0.097,0.614c0.085,0.329,0.221,0.612,0.417,0.864c0.213,0.275,0.498,0.496,0.851,0.656  c0.075,0.034,0.167,0.05,0.249,0.076c0.302,0.1,0.635,0.164,1.019,0.164h0.251h0.994v0.424v0.289v0.873v0.906v0.808v0.104h-1.76  h-0.561h-0.584v0.75v0.194v0.556h2.904v0.758v0.547h0.75h0.75v-0.263v-0.764v-0.278h0.497h1.163c0.224,0,0.428-0.039,0.622-0.095  c0.32-0.091,0.597-0.253,0.823-0.479c0.36-0.357,0.593-0.868,0.663-1.498c0.015-0.134,0.029-0.268,0.029-0.411v-0.343v-0.747v-0.348  c0-0.122-0.015-0.234-0.025-0.35C45.624,59.292,45.549,58.993,45.434,58.729z M40.382,55.903v0.809v0.777h-0.075h-1.17  c-0.084,0-0.154-0.01-0.229-0.017c-0.165-0.016-0.314-0.042-0.42-0.09c-0.124-0.057-0.222-0.128-0.284-0.209  c-0.069-0.089-0.116-0.189-0.149-0.316c-0.022-0.087-0.038-0.185-0.05-0.287c-0.015-0.123-0.023-0.254-0.023-0.396  c0-0.001,0-0.002,0-0.003v-0.418v-0.244c0-0.202,0.02-0.383,0.049-0.544c0.009-0.046,0.014-0.098,0.024-0.139  c0.033-0.129,0.081-0.231,0.149-0.321c0.062-0.079,0.158-0.15,0.279-0.204c0.161-0.072,0.387-0.11,0.653-0.11h1.245V55.903z   M44.18,60.27v0.754v0.388c0,0.145-0.013,0.262-0.031,0.367c-0.105,0.609-0.472,0.615-0.606,0.615h-0.876h-0.784V62.08v-0.826  v-0.796v-0.812v-0.657h1.66c0.423,0,0.638,0.331,0.638,0.984V60.27z"
                      ></path>
                    </svg>
                  </div>
                  <div>MultiCurrency</div>
                </button>
              </div>


              <div
                v-if="isMenuActive(2)"
                class="col-2 px-0"
                :style="'order:' + order(13)"
              >
                <button
                  class="btn-pos-menu"
                  v-on:click="gotoRoute('/pos-occupancy')"
                >
                  <div class="svg-container">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="29.888"
                      height="27.632"
                      viewBox="0 0 29.888 27.632"
                    >
                      <path
                        d="M58.485,84.785A1.169,1.169,0,0,1,60.416,86.1,13.816,13.816,0,1,1,62.4,74.956l.477-.818A1.171,1.171,0,0,1,64.9,75.319l-2.175,3.72a1.17,1.17,0,0,1-1.773.294L57.8,76.6a1.168,1.168,0,0,1,1.529-1.766l.82.71a11.476,11.476,0,1,0-1.66,9.244ZM47.992,69.939h2.23v1.92c2.013.291,3.559,1.4,3.643,3.779l-2.555.088a1.91,1.91,0,0,0-1.088-1.633v2.813c2.186.564,4.013,1.4,4.013,4.047a3.693,3.693,0,0,1-2.306,3.439,6.019,6.019,0,0,1-1.707.41v1.89h-2.23V84.775a4.354,4.354,0,0,1-4.013-4.239l2.485-.246A2.638,2.638,0,0,0,47.992,82.5V78.979c-1.839-.527-3.537-1.453-3.537-3.671,0-2.152,1.688-3.181,3.537-3.454V69.939Zm2.23,9.6v3.033a1.7,1.7,0,0,0,1.458-1.605c0-.755-.679-1.167-1.458-1.428ZM47.992,76.3V74.022c-.582.158-1.105.486-1.105,1.117C46.887,75.7,47.393,76.058,47.992,76.3Z"
                        transform="translate(-35.19 -64.5)"
                        fill="#969696"
                      />
                    </svg>
                  </div>
                  <div>{{ $t("update") }} {{ $t("occupancy") }}</div>
                </button>
              </div>

              <div
                v-if="isMenuActive(3)"
                class="col-2 px-0"
                :style="'order:' + order(3)"
              >
                <!-- INSTER 'PosOccupancyStatus' IN SHOW REFUND  -->
                <button
                  class="btn-pos-menu"
                  :disabled="btnDisable"
                  :class="btnDisable ? 'btnDisable' : ''"
                  v-on:click="onClickFooterBtn('PosSchedule')"
                >
                  <div class="svg-container">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="27"
                      height="27"
                      viewBox="0 0 27.328 42.496"
                    >
                      <g
                        id="Group_319"
                        data-name="Group 319"
                        transform="translate(-26 -13)"
                      >
                        <g
                          id="Group_318"
                          data-name="Group 318"
                          transform="translate(26 13)"
                        >
                          <path
                            id="Path_1100"
                            data-name="Path 1100"
                            d="M35.2,41.9l-.466,11.831a.087.087,0,0,1-.07.068H28.8a.086.086,0,0,1-.07-.068L28.26,41.9Zm.067-1.7.493-12.531a.091.091,0,0,0,.067.066h-8.2a.085.085,0,0,0,.067-.066L28.193,40.2Zm-9.2-21.531a5.666,5.666,0,1,1,5.666,5.666A5.666,5.666,0,0,1,26.065,18.666Zm9.632,0a3.966,3.966,0,1,0-3.966,3.966A3.966,3.966,0,0,0,35.7,18.666Zm-8.065,7.366h8.2a1.619,1.619,0,0,1,1.631,1.7L36.436,53.8a1.783,1.783,0,0,1-1.768,1.7H28.8a1.782,1.782,0,0,1-1.768-1.7L26,27.733A1.622,1.622,0,0,1,27.633,26.032Z"
                            transform="translate(-26 -13)"
                            fill="#969696"
                            fill-rule="evenodd"
                          />
                          <path
                            id="Path_1101"
                            data-name="Path 1101"
                            d="M63.359,37.931l-.622,15.8a.087.087,0,0,1-.07.068H56.8a.086.086,0,0,1-.07-.068l-.622-15.8Zm.067-1.7.337-8.565a.091.091,0,0,0,.067.066h-8.2a.085.085,0,0,0,.067-.066l.337,8.565h7.389ZM54.065,18.666a5.666,5.666,0,1,1,5.666,5.666A5.666,5.666,0,0,1,54.065,18.666Zm9.632,0a3.966,3.966,0,1,0-3.966,3.966A3.966,3.966,0,0,0,63.7,18.666Zm-8.065,7.366h8.2a1.619,1.619,0,0,1,1.631,1.7L64.436,53.8a1.783,1.783,0,0,1-1.768,1.7H56.8a1.782,1.782,0,0,1-1.768-1.7L54,27.733A1.622,1.622,0,0,1,55.633,26.032Z"
                            transform="translate(-38.135 -13)"
                            fill="#969696"
                            fill-rule="evenodd"
                          />
                          <path
                            id="Path_1102"
                            data-name="Path 1102"
                            d="M1.959,28l7.447.02V41.73H1.959Z"
                            fill="#969696"
                          />
                          <path
                            id="Path_1103"
                            data-name="Path 1103"
                            d="M17.964,23.463l7.774,1.092V41.277H17.964Z"
                            fill="#969696"
                          />
                        </g>
                      </g>
                    </svg>
                  </div>
                  <div class="ellipse">{{ $t("occupancy") }} </div>
                  <!-- {{ $tc("status", 1) }} -->
                </button>
                <!-- <button class="btn-pos-menu">
        <div class="svg-container">
          <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24.929"
          height="27.035"
          viewBox="0 0 24.929 27.035"
          >
          <g id="noun_Seat_1058955" transform="translate(0)">
            <g id="Group_304" data-name="Group 304" transform="translate(0 0)">
              <path
              id="Path_1060"
              data-name="Path 1060"
              d="M76.8,44.8H75.266a.768.768,0,0,0-.766.766v8.386a.768.768,0,0,0,.766.766H76.8a.768.768,0,0,0,.766-.766V45.566A.768.768,0,0,0,76.8,44.8Z"
              transform="translate(-52.634 -33.274)"
              fill="#969696"
              />
              <path
              id="Path_1061"
              data-name="Path 1061"
              d="M18.266,44.8a.768.768,0,0,0-.766.766v8.386a.768.768,0,0,0,.766.766H19.8a.768.768,0,0,0,.766-.766V45.566A.768.768,0,0,0,19.8,44.8Z"
              transform="translate(-17.462 -33.274)"
              fill="#969696"
              />
              <path
              id="Path_1062"
              data-name="Path 1062"
              d="M45.177,17.763A3.072,3.072,0,0,0,42.113,14.7h-9.65A3.072,3.072,0,0,0,29.4,17.763V31.243a.768.768,0,0,0,.766.766H44.373a.768.768,0,0,0,.766-.766V17.763Z"
              transform="translate(-24.805 -14.7)"
              fill="#969696"
              />
              <path
              id="Path_1063"
              data-name="Path 1063"
              d="M41.563,74.8h-23.4a.768.768,0,0,0-.766.766v2.489a.768.768,0,0,0,.766.766h23.4a.768.768,0,0,0,.766-.766V75.566A.768.768,0,0,0,41.563,74.8Z"
              transform="translate(-17.4 -51.786)"
              fill="#969696"
              />
              <path
              id="Path_1064"
              data-name="Path 1064"
              d="M44.411,63.9H30.166a.768.768,0,0,0-.766.766v1.072a.768.768,0,0,0,.766.766H44.373a.768.768,0,0,0,.766-.766V64.666A.714.714,0,0,0,44.411,63.9Z"
              transform="translate(-24.805 -45.06)"
              fill="#969696"
              />
            </g>
          </g>
        </svg>
      </div>
      <div>Seats</div>
                </button>-->
              </div>

              <div
                v-if="section.checkout == false && isMenuActive(14)"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(14)"
              >
              <!-- @click="checkAuthManager('posUserTransaction')" -->
                <button
                  class="btn-pos-menu"
                  @click="OpenFooterMenu('posUserTransaction')"

                >
                  <div class="svg-container">
                    <svg
                      height="100px"
                      width="100px"
                      fill="#969696"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      style="enable-background: new 0 0 100 100"
                      xml:space="preserve"
                    >
                      <path
                        d="M41.6,99.3H5.8c-1,0-1.9-0.8-1.9-1.9V2.7c0-1,0.8-1.9,1.9-1.9h60c0.5,0,1,0.2,1.3,0.5l17.3,17  c0.4,0.4,0.6,0.8,0.6,1.4V37c0,1-0.8,1.9-1.9,1.9c-1,0-1.9-0.8-1.9-1.9V20.5L65,4.6H7.7v90.8h33.8c1,0,1.9,0.8,1.9,1.9  S42.6,99.3,41.6,99.3z"
                      ></path>
                      <path
                        d="M18.9,33.3H59c1.2,0,2.2-1,2.2-2.2S60.2,29,59,29H18.9c-1.2,0-2.2,1-2.2,2.2S17.7,33.3,18.9,33.3z"
                      ></path>
                      <path
                        d="M19.1,21.2h40.1c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2H19.1c-1.2,0-2.2,1-2.2,2.2  C17,20.3,17.9,21.2,19.1,21.2z"
                      ></path>
                      <path
                        d="M19.1,45.7h23.4c1.2,0,2.2-1,2.2-2.2s-1-2.2-2.2-2.2H19.1c-1.2,0-2.2,1-2.2,2.2S17.9,45.7,19.1,45.7z"
                      ></path>
                      <path
                        d="M33.7,58.5H19c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h14.6c1.2,0,2.2,1,2.2,2.2S34.9,58.5,33.7,58.5z"
                      ></path>
                      <path
                        d="M70.8,65.3c0,0.7,0.6,1.2,1.3,1.2c0,0,0,0,0,0c0.7,0,1.3-0.6,1.3-1.3c0-1.9-1.3-5.5-5.9-6v-1.4  c0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3v1.4c-1.7,0.2-3.1,0.8-4.2,1.9c-1.6,1.6-1.7,3.7-1.7,4.1c0,0.5-0.1,2.7,1.5,4.4  c1,1.1,2.5,1.8,4.4,2v7.5c-3.1-0.6-3.3-3-3.3-3.5c0-0.7-0.6-1.3-1.3-1.2c-0.7,0-1.3,0.6-1.3,1.3c0,1.9,1.3,5.5,5.9,6v1.4  c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3v-1.4c1.7-0.2,3.1-0.8,4.2-1.9c1.6-1.6,1.7-3.7,1.7-4.1c0-0.5,0.1-2.7-1.5-4.4  c-1-1.1-2.5-1.8-4.4-2v-7.5C70.5,62.3,70.8,64.7,70.8,65.3z M64.9,69.1c-1.1-0.2-1.9-0.5-2.5-1.2c-1-1.1-0.8-2.5-0.8-2.5  c0-0.1,0-0.1,0-0.2c0,0,0-1.4,1-2.4c0.6-0.6,1.3-0.9,2.3-1.1V69.1z M70,72.9c1,1.1,0.8,2.5,0.8,2.5c0,0.1,0,0.1,0,0.2  c0,0,0,1.4-1,2.4c-0.6,0.6-1.3,0.9-2.3,1.1v-7.4C68.6,72,69.4,72.3,70,72.9z"
                      ></path>
                      <path
                        d="M66.8,41.6C50.9,41.6,38,54.5,38,70.4s12.9,28.8,28.8,28.8s28.8-12.9,28.8-28.8S82.7,41.6,66.8,41.6z   M93,69.1h-3.1c-0.3-5.4-2.5-10.4-5.9-14.2l2.1-2.1C90.2,57.1,92.7,62.9,93,69.1z M82.2,53.1c-3.9-3.6-9.1-5.8-14.7-6v-2.8  c6.5,0.2,12.4,2.7,16.9,6.7L82.2,53.1z M64.9,47.1c-5.6,0.4-10.6,2.7-14.4,6.3l-1.8-1.8c4.3-4.1,10-6.8,16.3-7.3V47.1z M48.7,55.3  c-3.2,3.8-5.2,8.6-5.5,13.8h-2.5c0.3-6,2.6-11.4,6.2-15.7L48.7,55.3z M43.2,71.7c0.3,5.5,2.5,10.5,6,14.4L47.4,88  c-3.9-4.4-6.4-10-6.7-16.2H43.2z M51,88c3.8,3.3,8.6,5.5,13.9,5.8v2.8c-6-0.4-11.5-2.9-15.7-6.8L51,88z M67.5,93.8  c5.4-0.2,10.3-2.3,14.2-5.5l2.1,2.1c-4.4,3.8-10.1,6.1-16.3,6.2V93.8z M66.5,91C55.2,91,46,81.8,46,70.4c0-11.3,9.2-20.5,20.5-20.5  c11.3,0,20.5,9.2,20.5,20.5C87.1,81.8,77.9,91,66.5,91z M85.7,88.6l-2.1-2.1c3.7-3.9,6-9.1,6.4-14.8H93C92.7,78.3,90,84.2,85.7,88.6  z"
                      ></path>
                    </svg>
                  </div>
                  <div>Transactions</div>
                </button>
              </div>

               <div
                v-if="section.checkout == false && isMenuActive(14) && false"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(14)"
              >
                <button
                  class="btn-pos-menu"
                  @click="showRefund('posUserFnbTransaction')"
                >
                  <div class="svg-container">
                    <svg
                      height="100px"
                      width="100px"
                      fill="#969696"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      style="enable-background: new 0 0 100 100"
                      xml:space="preserve"
                    >
                      <path
                        d="M41.6,99.3H5.8c-1,0-1.9-0.8-1.9-1.9V2.7c0-1,0.8-1.9,1.9-1.9h60c0.5,0,1,0.2,1.3,0.5l17.3,17  c0.4,0.4,0.6,0.8,0.6,1.4V37c0,1-0.8,1.9-1.9,1.9c-1,0-1.9-0.8-1.9-1.9V20.5L65,4.6H7.7v90.8h33.8c1,0,1.9,0.8,1.9,1.9  S42.6,99.3,41.6,99.3z"
                      ></path>
                      <path
                        d="M18.9,33.3H59c1.2,0,2.2-1,2.2-2.2S60.2,29,59,29H18.9c-1.2,0-2.2,1-2.2,2.2S17.7,33.3,18.9,33.3z"
                      ></path>
                      <path
                        d="M19.1,21.2h40.1c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2H19.1c-1.2,0-2.2,1-2.2,2.2  C17,20.3,17.9,21.2,19.1,21.2z"
                      ></path>
                      <path
                        d="M19.1,45.7h23.4c1.2,0,2.2-1,2.2-2.2s-1-2.2-2.2-2.2H19.1c-1.2,0-2.2,1-2.2,2.2S17.9,45.7,19.1,45.7z"
                      ></path>
                      <path
                        d="M33.7,58.5H19c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h14.6c1.2,0,2.2,1,2.2,2.2S34.9,58.5,33.7,58.5z"
                      ></path>
                      <path
                        d="M70.8,65.3c0,0.7,0.6,1.2,1.3,1.2c0,0,0,0,0,0c0.7,0,1.3-0.6,1.3-1.3c0-1.9-1.3-5.5-5.9-6v-1.4  c0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3v1.4c-1.7,0.2-3.1,0.8-4.2,1.9c-1.6,1.6-1.7,3.7-1.7,4.1c0,0.5-0.1,2.7,1.5,4.4  c1,1.1,2.5,1.8,4.4,2v7.5c-3.1-0.6-3.3-3-3.3-3.5c0-0.7-0.6-1.3-1.3-1.2c-0.7,0-1.3,0.6-1.3,1.3c0,1.9,1.3,5.5,5.9,6v1.4  c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3v-1.4c1.7-0.2,3.1-0.8,4.2-1.9c1.6-1.6,1.7-3.7,1.7-4.1c0-0.5,0.1-2.7-1.5-4.4  c-1-1.1-2.5-1.8-4.4-2v-7.5C70.5,62.3,70.8,64.7,70.8,65.3z M64.9,69.1c-1.1-0.2-1.9-0.5-2.5-1.2c-1-1.1-0.8-2.5-0.8-2.5  c0-0.1,0-0.1,0-0.2c0,0,0-1.4,1-2.4c0.6-0.6,1.3-0.9,2.3-1.1V69.1z M70,72.9c1,1.1,0.8,2.5,0.8,2.5c0,0.1,0,0.1,0,0.2  c0,0,0,1.4-1,2.4c-0.6,0.6-1.3,0.9-2.3,1.1v-7.4C68.6,72,69.4,72.3,70,72.9z"
                      ></path>
                      <path
                        d="M66.8,41.6C50.9,41.6,38,54.5,38,70.4s12.9,28.8,28.8,28.8s28.8-12.9,28.8-28.8S82.7,41.6,66.8,41.6z   M93,69.1h-3.1c-0.3-5.4-2.5-10.4-5.9-14.2l2.1-2.1C90.2,57.1,92.7,62.9,93,69.1z M82.2,53.1c-3.9-3.6-9.1-5.8-14.7-6v-2.8  c6.5,0.2,12.4,2.7,16.9,6.7L82.2,53.1z M64.9,47.1c-5.6,0.4-10.6,2.7-14.4,6.3l-1.8-1.8c4.3-4.1,10-6.8,16.3-7.3V47.1z M48.7,55.3  c-3.2,3.8-5.2,8.6-5.5,13.8h-2.5c0.3-6,2.6-11.4,6.2-15.7L48.7,55.3z M43.2,71.7c0.3,5.5,2.5,10.5,6,14.4L47.4,88  c-3.9-4.4-6.4-10-6.7-16.2H43.2z M51,88c3.8,3.3,8.6,5.5,13.9,5.8v2.8c-6-0.4-11.5-2.9-15.7-6.8L51,88z M67.5,93.8  c5.4-0.2,10.3-2.3,14.2-5.5l2.1,2.1c-4.4,3.8-10.1,6.1-16.3,6.2V93.8z M66.5,91C55.2,91,46,81.8,46,70.4c0-11.3,9.2-20.5,20.5-20.5  c11.3,0,20.5,9.2,20.5,20.5C87.1,81.8,77.9,91,66.5,91z M85.7,88.6l-2.1-2.1c3.7-3.9,6-9.1,6.4-14.8H93C92.7,78.3,90,84.2,85.7,88.6  z"
                      ></path>
                    </svg>
                  </div>
                  <div>Fnb Transactions</div>
                </button>
              </div>

              <div
                v-if="section.checkout == false && isMenuActive(15)"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(15)"
              >
                <button
                  class="btn-pos-menu"
                  @click="
                    $router.push({
                      name: 'Kitchen Pickup',
                      query: { isPosOperator: true },
                    })
                  "
                >
                  <div class="svg-container">
                    <svg
                      height="40px"
                      viewBox="0 -24 480 480"
                      width="40px"
                      fill="#969696"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="m472 96h-106.664062l-37.953126-91.078125c-1.242187-2.980469-4.152343-4.921875-7.382812-4.921875h-136c-4.417969 0-8 3.582031-8 8v32c0 4.417969 3.582031 8 8 8h106.457031l18 48h-60.457031c-4.417969 0-8 3.582031-8 8v48c0 4.417969 3.582031 8 8 8h8.457031l15.542969 264.472656c.25 4.230469 3.757812 7.535156 8 7.527344h160c4.242188.007812 7.75-3.296875 8-7.527344l15.542969-264.472656h8.457031c4.417969 0 8-3.582031 8-8v-48c0-4.417969-3.582031-8-8-8zm-168.503906-58.808594c-1.171875-3.125-4.160156-5.195312-7.496094-5.191406h-104v-16h122.664062l33.335938 80h-22.457031zm133.664062 298.808594h-34.96875c13.859375-12.101562 21.808594-29.601562 21.808594-48s-7.949219-35.898438-21.808594-48h40.617188zm-29.160156-48c0 26.507812-21.492188 48-48 48s-48-21.492188-48-48 21.492188-48 48-48c26.5.027344 47.972656 21.5 48 48zm-112 0c.011719 18.394531 7.960938 35.890625 21.808594 48h-34.96875l-5.648438-96h40.617188c-13.847656 12.109375-21.796875 29.605469-21.808594 48zm-8.457031 128-3.757813-64h152.429688l-3.757813 64zm156.210937-192h-167.507812l-3.757813-64h175.023438zm20.246094-80h-208v-32h208zm0 0"
                      />
                      <path
                        d="m408 384h-24c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8h24c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8zm0 0"
                      />
                      <path
                        d="m352 384h-8c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8zm0 0"
                      />
                      <path
                        d="m24 432h208c13.253906 0 24-10.746094 24-24v-32c-.015625-8.21875-4.242188-15.855469-11.199219-20.230469 4.273438-7.265625 4.273438-16.273437 0-23.539062 6.957031-4.375 11.183594-12.011719 11.199219-20.230469 0-43.257812-29.921875-88-80-88h-88c-57.777344 0-88 44.273438-88 88 .015625 8.21875 4.242188 15.855469 11.199219 20.230469-4.273438 7.265625-4.273438 16.273437 0 23.539062-6.957031 4.375-11.183594 12.011719-11.199219 20.230469v32c0 13.253906 10.746094 24 24 24zm216-24c0 4.417969-3.582031 8-8 8h-208c-4.417969 0-8-3.582031-8-8v-32c0-4.417969 3.582031-8 8-8h62.953125l118.984375 31.726562c3.667969.984376 7.523438-.75 9.222656-4.152343l13.785156-27.574219h3.054688c4.417969 0 8 3.582031 8 8zm-216-64c0-4.417969 3.582031-8 8-8h192c4.417969 0 8 3.582031 8 8s-3.582031 8-8 8h-192c-4.417969 0-8-3.582031-8-8zm187.054688 24-7.292969 14.59375-54.714844-14.59375zm-123.054688-128h88c44.144531 0 64 42.105469 64 72 0 4.417969-3.582031 8-8 8h-208c-4.417969 0-8-3.582031-8-8 0-28.945312 19.199219-72 72-72zm0 0"
                      />
                      <path
                        d="m88 272h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-8c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0"
                      />
                      <path
                        d="m56 304h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-8c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0"
                      />
                      <path
                        d="m96 296c0 4.417969 3.582031 8 8 8h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-8c-4.417969 0-8 3.582031-8 8zm0 0"
                      />
                      <path
                        d="m152 304h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-8c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0"
                      />
                      <path
                        d="m200 304h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-8c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0"
                      />
                      <path
                        d="m128 272h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-8c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0"
                      />
                      <path
                        d="m168 272h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-8c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0"
                      />
                    </svg>
                  </div>
                  <div>Kitchen Display</div>
                </button>
              </div>
              <!-- FNB REFUND ## -->
              <div
                v-if="section.checkout == false && isMenuActive(16)"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(16)"
              >
                <button class="btn-pos-menu" @click="showRefund('FnbRefund')">
                  <div class="svg-container">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="29.888"
                      height="27.632"
                      viewBox="0 0 29.888 27.632"
                    >
                      <path
                        d="M58.485,84.785A1.169,1.169,0,0,1,60.416,86.1,13.816,13.816,0,1,1,62.4,74.956l.477-.818A1.171,1.171,0,0,1,64.9,75.319l-2.175,3.72a1.17,1.17,0,0,1-1.773.294L57.8,76.6a1.168,1.168,0,0,1,1.529-1.766l.82.71a11.476,11.476,0,1,0-1.66,9.244ZM47.992,69.939h2.23v1.92c2.013.291,3.559,1.4,3.643,3.779l-2.555.088a1.91,1.91,0,0,0-1.088-1.633v2.813c2.186.564,4.013,1.4,4.013,4.047a3.693,3.693,0,0,1-2.306,3.439,6.019,6.019,0,0,1-1.707.41v1.89h-2.23V84.775a4.354,4.354,0,0,1-4.013-4.239l2.485-.246A2.638,2.638,0,0,0,47.992,82.5V78.979c-1.839-.527-3.537-1.453-3.537-3.671,0-2.152,1.688-3.181,3.537-3.454V69.939Zm2.23,9.6v3.033a1.7,1.7,0,0,0,1.458-1.605c0-.755-.679-1.167-1.458-1.428ZM47.992,76.3V74.022c-.582.158-1.105.486-1.105,1.117C46.887,75.7,47.393,76.058,47.992,76.3Z"
                        transform="translate(-35.19 -64.5)"
                        fill="#969696"
                      />
                    </svg>
                  </div>
                  <div>Refund FNB</div>
                </button>
              </div>

               <div
                v-if="section.checkout == false && isMenuActive(16) && false"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(16)"
              >
                <button class="btn-pos-menu" @click="onClickTestPrint()">
                  <div class="test-print">
                  </div>
                  <div>Test Print</div>
                </button>
              </div>

              <!-- FNB REFUND ## -->
              <div
                v-if="section.checkout == false && isMenuActive(16)"
                class="col-2 px-0 border-bottom child"
                :style="'order:' + order(17)"
              >

                <button class="btn-pos-menu"
                  :disabled="btnDisable"
                  :class="btnDisable ? 'btnDisable' : ''"
                  @click="onClickHardReload()">
                <div class="svg-container">
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.5511 0.925995C9.41815 0.917535 6.40535 2.13091 4.15282 4.30831V0.92594C4.15282 0.41455 3.73827 0 3.22688 0C2.71549 0 2.30099 0.41455 2.30099 0.92594V6.4815C2.30088 6.8802 2.55604 7.2342 2.93435 7.36015L8.4899 9.212C8.9757 9.3736 9.5005 9.11075 9.6621 8.625C9.8237 8.1392 9.56085 7.61435 9.07505 7.4528L4.97324 6.088C8.76235 1.96174 15.179 1.68842 19.3053 5.47755C23.4315 9.26665 23.7048 15.6834 19.9157 19.8096C16.1266 23.9358 9.70995 24.2091 5.5837 20.42C3.05397 18.097 1.87158 14.6516 2.44178 11.2648C2.53146 10.7613 2.19607 10.2805 1.69265 10.1908C1.18923 10.101 0.708385 10.4365 0.61865 10.9399C0.617675 10.9454 0.616755 10.9509 0.615885 10.9564C0.505045 11.6195 0.449273 12.2906 0.449219 12.9628C0.45676 19.6076 5.84145 24.9923 12.4861 24.9999C19.1339 25.0179 24.5376 19.6433 24.5556 12.9954C24.5735 6.34765 19.1989 0.943955 12.5511 0.925995Z"
                          fill="#969696"
                        />
                      </svg>
                    </div>
                  <div>Hard Reload</div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div :class="!section.movieDetail ? 'col-lg-4 col-xl-3 pl-0 col-md-4 col-sm-4' : '' ">
        <div class="pos-navigation">
          <div class="row">
            <div class="col-md-12">
              <!-- <button
          v-if="section.seatLayout == true && seatsSelected.length > 0"
          :class="['btn-blue-lg w-100 ', enableClass ? 'disabled': '']"
          v-on:click="onClickProceed()"
              >{{ $t('proceed') }}</button>-->
              <!-- v-else-if="section.seatLayout == true && seatsSelected.length > 0" -->

              <div
                class="row"
                v-if="section.seatLayout == true && seatsSelected.length > 0"
              >
                <div v-if="fnbactive" class="col-md-6 mb-2 pr-1">
                  <button
                    class="fs-14"
                    :disabled="checkoutBtndis"
                    :class="[
                      'btn-blue-lg w-100 ',
                      enableClass || checkoutBtndis ? 'disabled' : '',
                      noFnbItems ? 'no-fnb-btn' : '',
                    ]"
                    v-on:click="onClickProceed('isFnb')"
                  >
                    <div v-if="noFnbItems">
                      {{ $t("select") }} {{ $tc("fb", 1) }} <br />
                      <span class="noFnbItem">(No Fnb Items)</span>
                    </div>
                    <div v-else>{{ $t("select") }} {{ $tc("fb", 1) }}</div>
                  </button>
                </div>

                <div :class="fnbactive ? 'col-md-6 mb-2 pl-1' : 'col-md-12 mb-2'">
                  <button
                    class="fs-14"
                    :disabled="checkoutBtndis"
                    :class="[
                      'btn-blue-lg w-100 ',
                      enableClass || checkoutBtndis ? 'disabled' : '',
                    ]"
                    v-on:click="onClickProceed()"
                  >
                    {{ $t("checkout") }}
                  </button>
                </div>
              </div>
              <div class="row" v-else>
                <div v-if="checkoutOnlyCashCard" class="col-md-6 mb-2 pl-1">
                  <button
                    class="fs-14"
                    :class="['btn-blue-lg w-100 ']"
                    v-on:click="onClickProceed()"
                  >
                    {{ $t("checkout") }}
                  </button>
                </div>
              </div>

              <div v-if="paymentshowbutton" class="row">
                <div class="col-md-6 mb-2 pr-2">
                  <button
                    :class="[
                      'btn-blue-lg px-1 w-100',
                      enableClass ? 'disabled' : '',
                    ]"
                    v-on:click="$bvModal.show('loyaltyMoadal')"
                  >
                    <span class="fs-12"
                      >{{ $t(isOldCustomer ? "update" : "add") }}
                      {{ $t("customer") }} {{ $tc("details", 1) }}</span
                    >
                  </button>
                </div>
                <div class="col-md-6 pl-1">
                  <button
                    :class="[
                      'btn-blue-lg w-100 px-1',
                      enableClass || [2,3].includes(selectedPaymentMode.pm_id) && (USE_TIM_INTEGRATION == 'Y' || USE_NEOLEAP_POS_PAYMENT == 'Y') ? 'disabled' : '',
                    ]"
                    :style="[2,3].includes(selectedPaymentMode.pm_id) && (USE_TIM_INTEGRATION == 'Y' || USE_NEOLEAP_POS_PAYMENT == 'Y')  ? 'pointer-events: none;' : ''"
                    v-on:click="onClickCheckout()"
                  >
                    <span class="fs-14" v-if="DirectPrint == 'Y'">{{
                      $t("print")
                    }}</span>
                    <span class="fs-14" v-else>{{ $t("generatebill") }}</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-md-12" v-if="section.cashCardTopup">
              <button
                class="btn-blue-lg w-100"
                v-on:click="checkTopUpCashInput()"
              >
                {{ $t("topup") }}
              </button>
            </div>
            <div class="col-md-12 mt-2" v-if="section.cashCardTopup">
              <button class="btn-white-lg w-100" v-on:click="onClickCancel()">
                {{ $t("cancel") }}
              </button>
            </div>

            <div class="col-md-6 pr-1" v-if="isUnpaidBooking">
              <button class="btn-white-lg w-100" v-on:click="onClickCancel()">
                {{ $t("cancel") }}
              </button>
            </div>
            <div class="col-md-6 pr-1" v-if="showbutton">
              <button class="btn-white-lg w-100" v-on:click="onClickBack()">
                {{ $t("back") }}
              </button>
            </div>
            <div
              v-if="paymentshowbutton && isLoyaltyApplied"
              class="col-md-6 pr-1"
            >
              <button
                class="btn-white-lg w-100"
                v-if="paymentshowbutton && isLoyaltyApplied"
                v-on:click="onResetLoyalty()"
              >
                {{ $t("cancel") }}
              </button>
            </div>
            <div class="col-md-6 pl-2">
              <button
                v-if="showbutton && section.seatLayout == true"
                v-on:click="onCancelHandler"
                class="btn-white-lg w-100"
              >
                {{ $t("Clear") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <MultiCurrency
                    v-bind:showModal="multiCurrencyModal"
                    v-bind:sectionType="'POS'"
                  ></MultiCurrency>

    <!-- cinemaManagerLoginPopup -->
    <b-modal
      hide-footer
      no-close-on-esc
      id="cinemaManagerLoginPopup"
      ref="cinemaManagerLoginPopup"
      title="Cinema Manage Details"
    >
      <div class="col-10 text-center mx-auto mb-3">
        <div>
          <p class="fs-16 text-muted mb-4">
            Because you have selected VIP seats / Block seats, will require
            <span class="font-weight-semi-bold">Cinema Manager</span> login
          </p>

          <div class="input-material">
            <input
              type="text"
              v-model="username"
              name="username"
              id="username"
              v-validate="'required'"
              placeholder="username"
            />
            <label>Cinema Manager username</label>
          </div>

          <p class="error_message">
            <span v-if="submitted && errors.has('username')">{{
              errors.first("username")
            }}</span>
          </p>

          <div class="input-material">
            <input
              type="password"
              v-model="password"
              name="password"
              id="password"
              v-validate="'required'"
              placeholder="password"
            />
            <label>Cinema Manager Password</label>
          </div>

          <p class="error_message">
            <span v-if="submitted && errors.has('password')">{{
              errors.first("password")
            }}</span>
          </p>

          <div class="d-flex">
            <button
              @click.prevent.stop="$bvModal.hide('cinemaManagerLoginPopup')"
              class="btn-white-lg w-50 mr-2"
            >
              Cancel
            </button>
            <button
              @click.prevent.stop="CheckLogin"
              class="btn-blue-lg w-50 ml-2"
            >
              Proceed
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- MULTI SEATS MODAL -->
    <b-modal
      hide-footer
      hide-header
      hide-backdrop
      no-close-on-esc
      no-close-on-backdrop
      ref="multiSeatsModal"
      id="multiSeatsModal"
      class="seat_select_modal"
    >
      <div class="text-center pt-3">
        <h5 class="font-weight-semi-bold mb-4">
          You opted for
          <strong>{{ totalNumberOfSeats }}</strong>
          but selected only
          <strong>{{ seatsSelected.length }}</strong>
          <br />Are you sure you want to proceed?
        </h5>

        <button
          class="btn-outline-blue-lg"
          @click="$refs.multiSeatsModal.hide()"
        >
          <span class="fs-18">No</span>
        </button>
        <span class="mx-2"></span>
        <button class="btn-blue-lg" @click="reserveSeats()">
          <span class="fs-18">Yes</span>
        </button>
      </div>
    </b-modal>

    <!-- LOYALTY MODAL -->
    <b-modal
      hide-footer
      hide-backdrop
      no-close-on-esc
      no-close-on-backdrop
      title="Add Customer Details"
      ref="loyaltyMoadal"
      id="loyaltyMoadal"
    >
      <div class="col-12 h-100">
        <div class="pos-mobile-number">
          <div>
            <div class="row">
              <div class="col-12 mb-4">
                <div class="country-code">
                  <div class="d-flex align-items-center">
                    <!--variant="dropdown-curve-lg bg-theme-light"-->
                    <b-dropdown
                      :text="getCustMobCode ? getCustMobCode : 'Code'"
                      variant="dropdown-curve"
                      class="w-50 text-center mr-3"
                       >
                      <div class="px-2 pb-2">
                        <input
                          required
                          autofocus
                          type="search"
                          placeholder="Search Code"
                          class="form-control form-control-sm"
                          v-on:keyup="onSearchCode($event.target.value)"
                          v-on:keydown="onSearchCode($event.target.value)"
                          v-on:search="onSearchCode($event.target.value)"
                          v-model="searchCode"
                        />
                      </div>
                      <b-dropdown-item
                        href="#"
                        v-for="(countrycode, countryIndex) in Countries"
                        :key="countryIndex"
                        v-on:click="onSelectHandler(countrycode)"
                        v-if="countrycode.country_mob_code != null"
                        >{{ countrycode.country_mob_code }}
                      </b-dropdown-item>
                    </b-dropdown>
                    <input
                      type="number"
                      :disabled="isEdit"
                      v-model="input_number"
                      placeholder="Mobile Number"
                      class="mobile-number"
                      v-on:keydown="
                        (e) => {
                          if (!/[0-9]/.test(e.key) && e.keyCode !== 8) {
                            e.preventDefault();
                          }
                        }
                      "
                    />
                    <span
                      @click="onEditPhoneNumber()"
                      class="edit-pen ml-2"
                    ></span>
                  </div>
                </div>
              </div>
              <!-- <div> -->
              <form class="row">
                <!--class="col-12 mb-4"-->
                <div v-if="isSearch" class="col-12">
                  <input
                    type="email"
                    v-model="email_address"
                    name="Email Address"
                    placeholder="Email Address"
                    v-validate="'required|email'"
                    id="custEmailAdd"
                     @focus="onClickAddCustInputHandler('showEmailKeyboard')"
                  />
                  <p class="error_message">
                    <span v-if="submitted && errors.has('Email Address')">{{
                      errors.first("Email Address")
                    }}</span>
                  </p>
                  <VkeyboardFloat
                    :ID="'custEmailAdd'"
                    :onClickFun="() => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if(x == 'showEmailKeyboard') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      })
                    }"
                  />
                <Vkeyboard
                  :inputName="'custEmailAdd'"
                  :showOrHide="keyboardsVisible.showEmailKeyboard"
                  :initialValue="email_address"
                  @onChangeEvent="() => {}"
                  @onKeyEnter="() => {
                    keyboardsVisible.showEmailKeyboard = false;
                  }"
                  @changeKeyboardInput="email_address = $event"
                  @onClickClose="() => {
                    keyboardsVisible.showEmailKeyboard = false;
                  }"
                />
                </div>
                <!--class="col-6 mb-4"-->
                <div v-if="isSearch" class="col-6">
                  <input
                    type="text"
                    name="First Name"
                    v-model="first_name"
                    placeholder="First Name"
                    v-validate="'required'"
                    id="custfirstname"
                      @focus="onClickAddCustInputHandler('showFirstNameKeyboard')"
                  />
                  <p class="error_message">
                    <span v-if="submitted && errors.has('First Name')">{{
                      errors.first("First Name")
                    }}</span>
                  </p>
                  <VkeyboardFloat
                    :ID="'custfirstname'"
                    :onClickFun="() => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if(x == 'showFirstNameKeyboard') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      })
                    }"
                  />
                <Vkeyboard
                  :inputName="'custfirstname'"
                  :showOrHide="keyboardsVisible.showFirstNameKeyboard"
                  :initialValue="first_name"
                  @onChangeEvent="() => {}"
                  @onKeyEnter="() => {
                    keyboardsVisible.showFirstNameKeyboard = false;
                  }"
                  @changeKeyboardInput="first_name = $event"
                  @onClickClose="() => {
                    keyboardsVisible.showFirstNameKeyboard = false;
                  }"
                />
                </div>
                <!--class="col-6 mb-4"-->
                <div v-if="isSearch" class="col-6">
                  <input
                    type="text"
                    name="Last Name"
                    v-validate="'required'"
                    v-model="last_name"
                    placeholder="Last name"
                    id="custlastname"
                     @focus="onClickAddCustInputHandler('showLastNameKeyboard')"
                  />
                  <p class="error_message">
                    <span v-if="submitted && errors.has('Last Name')">{{
                      errors.first("Last Name")
                    }}</span>
                  </p>
                  <VkeyboardFloat
                    :ID="'custlastname'"
                    :onClickFun="() => {
                      Object.keys(keyboardsVisible).map((x) => {
                        if(x == 'showLastNameKeyboard') {
                          keyboardsVisible[x] = !keyboardsVisible[x];
                        } else {
                          keyboardsVisible[x] = false;
                        }
                      })
                    }"
                  />
                <Vkeyboard
                  :inputName="'custlastname'"
                  :showOrHide="keyboardsVisible.showLastNameKeyboard"
                  :initialValue="last_name"
                  @onChangeEvent="() => {}"
                  @onKeyEnter="() => {
                    keyboardsVisible.showLastNameKeyboard = false;
                  }"
                  @changeKeyboardInput="last_name = $event"
                  @onClickClose="() => {
                    keyboardsVisible.showLastNameKeyboard = false;
                  }"
                />
                </div>

                <div v-if="isSearch" class="col-12">
                  <div class="d-flex pb-2">
                      <b-form-checkbox
                      class="j-checkbox"
                      v-model="is_loyality_subscribe"
                      unchecked-value="N"
                      value="Y"

                    ></b-form-checkbox>
                    <span>{{ $t("subscribeloyality") }}</span>
                  </div>
                </div>
              </form>
              <!-- </div> -->

              <div class="col-11 mx-auto">
                <div class="row">
                  <!-- <div class="col-4 mb-2" v-for="(loop , mobile) in 12" :key="mobile">
                  <button>{{mobile}}</button>-->

                  <div
                    class="col-4 mb-2"
                    v-for="(value, index) in phone_value"
                    :key="index"
                  >
                    <button
                      v-if="index == phone_value.length - 1"
                      v-on:click="onSliceNUmber()"
                      class="number"
                    >
                      {{ value.name }}
                    </button>
                    <button
                      v-else-if="value.name != ''"
                      v-on:click="onClicknumber(index)"
                      class="number"
                    >
                      {{ value.name }}
                    </button>
                    <button
                      v-else
                      @click.prevent.stop="clearInput"
                      class="number"
                    >
                      C
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center mx-auto">
          <div class>
            <button
              @click="$bvModal.hide('loyaltyMoadal')"
              class="btn-outline-blue-lg bg-transparent text-dark mr-1"
            >
              Cancel
            </button>
            <button
              v-on:click="onClickDelete()"
              class="btn-outline-blue-lg bg-transparent text-dark mr-1"
            >
              Clear
            </button>
            <button
              v-if="!isSearch"
              v-on:click="onSearch()"
              class="btn-blue-lg bg-blue text-white ml-1"
            >
              Search
            </button>
            <button
              v-else-if="isOldCustomer"
              v-on:click="onUpdateCustomerDetails()"
              class="btn-blue-lg bg-blue text-white ml-1"
            >
              Update
            </button>
            <button
              v-else
              v-on:click="onSaveDetails()"
              class="btn-blue-lg bg-blue text-white ml-1"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal hide-footer id="cashCardOLD" ref="cashCardOLD" title="Cash Card">
      <div>
        <!-- <div class="row border-bottom pb-2 mb-2">
          <div class="col-8">
            <span class="font-weight-semi-bold">PAYMENT MODE</span>
          </div>
          <div class="col-4 text-center">
            <span class="font-weight-semi-bold">AMOUNT</span>
          </div>
        </div> -->

        <!-- LOOP THIS DIV FOR DIFFERENT PAYMENT METHODS -->
        <div class="col-12" v-if="cust_id !== ''">
          <div class="row py-2">
            <div class="col-6 align-self-center">
              <span>Card Number</span>
            </div>
            <div class="col-6 align-self-center">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    CashCardDetail && CashCardDetail.cardNumber.length > 0
                      ? 'shift-up'
                      : ''
                  "
                  >Select Cash Card</label
                >
                <b-dropdown
                  :text="
                    CashCardDetail.cardNumber ? CashCardDetail.cardNumber : ''
                  "
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <b-dropdown-item
                    href="#"
                    name="cashCardDropdown"
                    id="cashCardDropdown"
                    v-on:click="
                      selectCashCard({ cash_card_number: 'Add New Card' })
                    "
                    >Add New Card</b-dropdown-item
                  >
                  <b-dropdown-item
                    v-for="(card, cardIndex) in cashCards"
                    href="#"
                    :key="cardIndex"
                    name="cashCardDropdown"
                    id="cashCardDropdown"
                    v-on:click="selectCashCard(card)"
                    >{{ card.cash_card_number }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>
          </div>
          <div class="row py-2">
            <div class="col-12" v-if="cashCardNewInput">
              <input
                class="rounded border w-100 py-2"
                v-model="cashCardNumberNewValue"
                placeholder="Card Number"
              />
            </div>
          </div>

          <div class="row py-2" v-if="CashCardDetail.cardNumber !== ''">
            <div class="col-6 align-self-center">
              <span
                >{{
                  !cashCardNewInput && CashCardDetail.cash_card_id !== ""
                    ? "Credit"
                    : "Initial"
                }}
                Amount</span
              >
            </div>
            <div class="col-6">
              <input
                class="rounded border py-2 w-100"
                v-model="CashCardDetail.cardAmount"
                type="number"
              />
            </div>
          </div>
          <div class="row py-2" v-if="false">
            <!-- v-if="!cashCardNewInput && CashCardDetail.cash_card_id !== ''" -->
            <div class="col-6 align-self-center">
              <span>Credit Amount</span>
            </div>
            <div class="col-6">
              <input
                class="btn-transparent rounded border py-2 w-100"
                v-model="cashCardCreditAmount"
                type="number"
              />
            </div>
          </div>
        </div>
        <div v-else>
          Please add customer details to view and add cash cards.
        </div>
        <!-- <div
          v-for="(singlePayment, singlePaymentIndex) in paymentModes"
          :key="singlePaymentIndex"
          class="col-12"
        >
          <div class="row py-2">
            <div class="col-8 align-self-center">
              <span>{{ singlePayment.pm_payment_mode }}</span>
            </div>

          </div>
        </div>
      -->

        <div class="col-12 pt-3 text-center" v-if="cust_id !== ''">
          <button @click="AddCashCard()" class="btn-blue-lg px-5">
            Submit
          </button>
          <button
            v-if="!cashCardNewInput && CashCardDetail.cash_card_id !== ''"
            @click="onClickViewTransactions()"
            class="btn-blue-lg px-5"
          >
            View Transactions
          </button>
        </div>
      </div>
    </b-modal>
    <!-- CASH CARD LOGS MODAL -->
    <b-modal
      hide-footer
      id="cashCardLogs"
      ref="cashCardLogs"
      title="Cash Card Logs"
      size="lg"
    >
      <div>
        <div class="col-12 mt-4">
          <table class="table">
            <thead>
              <tr>
                <th class="text-center">Change Amount</th>
                <th class="text-center">Credited/Debited By</th>
                <th class="text-center">Closing Balance</th>
                <th class="text-center">Created At</th>
              </tr>
            </thead>
            <tbody v-if="getCashCardLogs.length == 0">
              <tr>
                <td colspan="4">
                  <h3 class="text-center">{{ "No records found" }}</h3>
                </td>
              </tr>
            </tbody>
            <tbody
              v-else
              v-for="(log, logIndex) in getCashCardLogs"
              :key="logIndex"
            >
              <tr>
                <td
                  class="text-center"
                  v-if="log.credit_amount"
                  style="color: green"
                >
                  {{ log.credit_amount }}
                </td>
                <td
                  class="text-center"
                  v-else-if="log.debit_amount"
                  style="color: red"
                >
                  -{{ log.debit_amount }}
                </td>
                <td class="text-center" v-else style="color: red">0</td>
                <td class="text-center">{{ log.username }}</td>
                <td class="text-center">{{ log.current_balance }}</td>
                <td class="text-center">
                  {{ log.log_created_at | fulldaydateparse }}
                </td>
              </tr>
            </tbody>
          </table>
          <b-pagination
            v-if="totalRows > 0"
            v-model="currentPage"
            :total-rows="totalRows"
            @change="onChangePagination($event)"
            :per-page="perPage"
            aria-controls="my-table"
          />
        </div>

        <div class="col-12 pt-3 text-center border-top">
          <button @click="onClickCloseCashCardLogs()" class="btn-blue-lg px-5">
            Close
          </button>
        </div>
      </div>
    </b-modal>
    <!-- CASH CARD LOGS MODAL -->
    <b-modal
      hide-footer
      id="splitPayments"
      ref="splitPayments"
      title="Split Payments"
    >
      <div>
        <div class="row border-bottom pb-2 mb-2">
          <div class="col-8">
            <span class="font-weight-semi-bold">PAYMENT MODE</span>
          </div>
          <div class="col-4 text-center">
            <span class="font-weight-semi-bold">AMOUNT</span>
          </div>
        </div>

        <!-- LOOP THIS DIV FOR DIFFERENT PAYMENT METHODS -->
        <div
          v-for="(singlePayment, singlePaymentIndex) in paymentModesArray"
          :key="singlePaymentIndex"
          class="col-12"
          v-if="singlePayment.pm_id !== 13"
        >
          <div class="row py-2" v-if="singlePayment.pm_id !== 10">
            <div class="col-8 align-self-center">
              <span>{{ singlePayment.pm_payment_mode }}</span>
            </div>
            <div class="col-4">
              <input
                class="btn-transparent rounded border py-2 w-100"
                :value="singlePayment.amount"
                :disabled="singlePayment.pm_id == 11"
                :id="`${singlePaymentIndex}_split_amount`"
                @click="onClickInputHandler(singlePayment)"
                @input="
                  onChangePaymentValue({
                    index: singlePaymentIndex,
                    value: $event.target.value,
                  })
                "
              />
               <VkeyboardFloat
                    :ID="`${singlePaymentIndex}_split_amount`"
                    :onClickFun="() => onClickShowKeyboard(singlePayment)"
                  />
                  <Vkeyboard
                    :inputName="`${singlePaymentIndex}_split_amount`"
                    :showOrHide="singlePayment.keyboardActive"
                    :initialValue="String(singlePayment.amount)"
                    :keyBoardType="'numeric'"
                    @onChangeEvent="() => {}"
                    @onKeyEnter="onCloseKeyboard(singlePayment)"
                    @changeKeyboardInput="onChangePaymentValue({
                        index: singlePaymentIndex,
                        value: $event,
                      })"
                    @onClickClose="onCloseKeyboard(singlePayment)"
                  />
            </div>
          </div>
        </div>
        <!-- <div class="col-12">
          <div class="row py-2">
            <div class="col-8 align-self-center">
              <span>Credit Card</span>
            </div>
            <div class="col-4">
              <button class="btn-transparent rounded border py-2 w-100">100</button>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row py-2">
            <div class="col-8 align-self-center">
              <span>Cash Card</span>
            </div>
            <div class="col-4">
              <button class="btn-transparent rounded border py-2 w-100">100</button>
            </div>
          </div>
        </div>-->

        <div class="col-12 border-top mt-2">
          <div class="row py-2">
            <div class="col-8">
              <span>Total</span>
            </div>
            <div class="col-4 text-center">
              <span class="font-weight-semi-bold">{{ total_payment }}</span>
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="row pb-2">
            <div class="col-8">
              <span>Total amount to be paid:</span>
            </div>
            <div class="col-4 text-center">
              <span class="font-weight-semi-bold">{{
                parseFloat(
                  parseFloat(totalAmount) + parseFloat(CashCardAmount)
                ).toFixed(2)
              }}</span>
            </div>
          </div>
        </div>

        <div class="col-12 border-top mt-2">
          <div class="row py-2">
            <div class="col-8">
              <span>Offer Price</span>
            </div>
            <div class="col-4 text-center">
              <span class="font-weight-semi-bold"
                >-{{ getOfferPrice || getloyaltyAmount }}</span
              >
            </div>
          </div>
        </div>

        <div class="col-12 border-top">
          <div class="row py-3">
            <div class="col-8">
              <span class="fs-16 font-weight-semi-bold">Balance Amount</span>
            </div>
            <div class="col-4 text-center">
              <strong class="fs-16">{{
                parseFloat(balance_amount).toFixed(2)
              }}</strong>
            </div>
          </div>
        </div>

        <div class="col-12 pt-3 text-center">
          <button @click="onPayViaSplitMethod()" class="btn-blue-lg px-5">
            Submit
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      hide-footer
      hide-header
      hide-backdrop
      no-close-on-backdrop
      id="showRateCardPrice"
      ref="showRateCardPrice"
      title="Show Rate Card"
      class=""
      size="xl"
    >
      <div class="d-flex flex-column">
        <div class="d-flex border-bottom border-dark">
          <div class="col-6">
            <h5 class="font-weight-bold mt-2">Show Rate Card</h5>
          </div>
          <div class="col-6 text-right">
            <button
              class="btn-modal-close ml-auto"
              @click="$bvModal.hide('showRateCardPrice')"
            >
              &times;
            </button>
          </div>
        </div>

        <div
          class="d-flex flex-column"
          v-if="seatsSelectedRateGroup.length > 0"
        >
          <div
            class="d-flex align-items-center border-bottom flex-wrap"
            v-for="(item, index) in seatsSelectedRateGroupNew"
            :key="index"
          >
            <div
              class="seat-type gold"
              :style="'color:' + item.AllSeats[0].sst_seat_color_code"
            >
              <div class="st-name">{{ item.srt_name }}</div>
              <div>{{ item.totalSelected }}/{{ item.AllSeats.length }}</div>
            </div>
            <div
              class="d-flex align-items-center flex-wrap"
              v-for="(rg, rg_index) in item.rate_card_group"
              :key="rg_index"
            >
              <div class="category">
                <div class="category-name">
                  {{ rg.tt_name }}
                </div>
                <div class="category-price">
                  {{ currencyData.curr_code }}
                  {{ currFormat(rg.rc_total_amount) }}
                </div>
                <div class="category-seats">
                  <div
                    class="mod-btn"
                    :id="`decrement${index + 1}${rg_index + 1}`"
                    @click="totalCount(rg, index, rg_index, 'decrement')"
                    :class="rg.totalSeatSelected == 0 ? 'disabled' : ''"
                  >
                    -
                  </div>
                  <div>{{ rg.totalSeatSelected }}</div>
                  <div
                    class="mod-btn"
                    :id="`increment${index + 1}${rg_index + 1}`"
                    @click="totalCount(rg, index, rg_index, 'increment')"
                    :class="
                      item.totalSelected == item.AllSeats.length
                        ? 'disabled'
                        : ''
                    "
                  >
                    +
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex flex-column w-100 px-4 border-bottom py-2">
            <div
              class="
                d-flex
                w-100
                justify-content-between
                align-items-center
                border-bottom
              "
            >
              <h5>Total Seats</h5>
              <h4 class="font-weight-bold">
                {{ totalSeatBooked }}/{{
                  this.$store.getters.SELECTED_SEATS.length
                }}
              </h4>
            </div>
            <div
              class="
                d-flex
                w-100
                justify-content-between
                align-items-center
                py-2
              "
            >
              <h5>Total Price</h5>
              <h3 class="font-weight-bold">
                {{ currencyData.curr_code }} {{ currFormat(totalAmountPrice) }}
              </h3>
            </div>
          </div>

          <div class="w-100 d-flex align-items-center justify-content-center">
            <button
            v-if="accessLimitation != 'POSONLY'"
              class="fl btn-blue my-3 h5"
              :class="[
                totalSeatBooked == this.$store.getters.SELECTED_SEATS.length
                  ? noFnbItems
                    ? 'no-fnb-btn'
                    : ''
                  : 'btn-submit-disabled',
              ]"
              @click="RateCardSubmit('isFnb')"
            >
              <div v-if="noFnbItems" class="nfs-17">
                {{ $t("select") }} {{ $tc("fb", 1) }} <br />
                <span class="noFnbItem">(No Fnb Items)</span>
              </div>
              <div v-else>{{ $t("select") }} {{ $tc("fb", 1) }}</div>
            </button>
            <button
              class="fl btn-blue my-3 h5"
              :class="
                totalSeatBooked == this.$store.getters.SELECTED_SEATS.length
                  ? ''
                  : 'btn-submit-disabled'
              "
              @click="RateCardSubmit"
            >
              Checkout
            </button>
          </div>
        </div>
      </div>
    </b-modal>
      <b-modal
      id="bookUnpaidConfirm"
      title="Book Unpaid Booking?"
      hide-footer
      no-close-on-backdrop
    >
      <div class="text-center pb-1">
        <p class="fs-16 mb-2">
          {{
            `Are you sure you want to book Unpaid Booking For Reservation ID ${reservationId}`
          }}
        </p>

        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('bookUnpaidConfirm')"
        >
          Cancel
        </button>
        <span class="mx-1"></span>
        <button
          class="btn btn-blue btn-blue-lg px-4 fs-14"
          @click.prevent.stop="bookUnPaidBooking"
        >
          Confirm
        </button>
      </div>
    </b-modal>

     <b-modal
      id="BookConfirmUnPaid"
      title="Booking Done"
      hide-footer
      no-close-on-backdrop
    >
      <div class="text-center pb-1">
        <p class="fs-16 mb-2">
          {{
            `Booking Done For ${reservationId}`
          }}
        </p>


        <span class="mx-1"></span>
        <button
          class="btn btn-blue btn-blue-lg px-4 fs-14"
          @click.prevent.stop="callClose"
        >
          Confirm
        </button>
      </div>
    </b-modal>

    <b-modal
      id="testprintOptions"
      ref="testprintOptions"
      title="Test Print"
      hide-footer
      hide-header
      size="sm"
      centered
    >
      <div class="text-center">
              <button
                @click="printHandler(1)"
                class="btn-blue-lg bg-blue text-white ml-1"
              >
                Ticket
              </button>
              <button
                @click="printHandler(2)"
                class="btn-blue-lg bg-blue text-white ml-1"
              >
                Receipt
              </button>
            </div>
    </b-modal>

    <div ref="onPrint" class="d-none">
      <div v-html="EjsData"></div>
    </div>
    <!-- <CashCardPos fullscreen @hideCashCardPos="hideCashCardPos" v-if="showCashCardPos">
      </CashCardPos> -->
    <div id="v-idle" style="display: none">
      <!-- :duration in seconds-->
      <v-idle
        @idle="onIdleCheckout"
        :events="['mousemove', 'keypress', 'ontouchstart', 'onclick']"
        :loop="true"
        :duration="pos_final_page_standBy_time * 60"
      />
    </div>
    <!-- <ManagerAuthLogin :moduleName="managerAuthObj['moduleName']" :onCheckAuth="onCheckAuthentication" :refId="managerAuthObj['refName']" /> -->
    <ManagerAuthLogin :moduleName="'posUserTransaction'" :onCheckAuth="onCheckAuthentication" :refId="'posUserTransaction'" />
    <ManagerAuthLogin :moduleName="'posUserCollection'" :onCheckAuth="onCheckAuthentication" :refId="'posUserCollection'" />
  </footer>
</template>
<script>
import MasterService from "@/services/MasterService.js";
import UserService from "@/services/UserService.js";
import PosService from "@/services/PosService.js";
import { mapState, mapGetters, mapActions } from "vuex";
import { EventBus } from "@/main";
import MultiCurrency from "@/components/Partials/PosCurrencyConvertor.vue";
import CashCardPos from "@/components/Partials/CashCardPos";
import { directive as onClickaway } from "vue-clickaway";
import Printd from "printd";
import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
import { BASEURL } from "@/config/index";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import _ from "lodash";

export default {
  components: {
    MultiCurrency,
    CashCardPos,
    Vkeyboard,
    VkeyboardFloat,
    ManagerAuthLogin
  },
  props: {
    section: { type: Object },
    onBackHandler: { type: Function },
     onClickCloseButton: { type: Function },
    onUnpaidBookingCancel: { type: Function },
    onClickHandler: { type: Function },
    enableClass: { type: Boolean },
    onClickSeat: { type: Function },
    onClickYes: { type: Boolean },
  },
   directives: {
    onClickaway: onClickaway
  },
  data() {
    return {
      // isSearch: false,
      // input_number: "",
      // email_address: "",
      // first_name: "",
      // last_name: "",
      btnDisable: false,
      menuName: "",
      managerAuthObj: {
        moduleName: "",
        refName: "",
      },
      checkoutBtndis: false,
      authModuleName:'',
      fnb_order_code: null,
       noAuth: false,
       EjsData: null,
       isReprint: false,
       fnb_transaction_id: null,

      accessLimitation: '',
      keyboardsVisible: {
        showFirstNameKeyboard: false,
        showLastNameKeyboard: false,
        showEmailKeyboard: false,
      },
      cashCardCreditAmount: null,
      totalRows: null,
      perPage: 5,
      currentPage: 1,
      Countries: [],
      SelectedCountryCode: "Code",
      CountriesMethod: {
        GET: "/admin/",
        tableName: "ms_countries",
        urlKey: "countries",
      },
      phone_value: [
        { name: "1" },
        { name: "2" },
        { name: "3" },
        { name: "4" },
        { name: "5" },
        { name: "6" },
        { name: "7" },
        { name: "8" },
        { name: "9" },
        { name: "" },
        { name: "0" },
        { name: "<-" },
      ],
      boxOfficeFNBflag: false,
      isFnbSelected: false,
      isUnpaidBooking: false,
      posHiddenMenus: false,
      showbutton: false,
      paymentshowbutton: false,
      roleid: "",
      fnbactive: false,
      cinema_id: "",
      submitted: false,
      username: "",
      password: "",
      submitted: false,
      reserveSeatsImmediate: "Y",
      CashCardDetail: {
        cash_card_id: "",
        cardNumber: "",
        cardAmount: "",
      },
      cashCardNewInput: false,
      cashCardNumberNewValue: "",
      checkoutOnlyCashCard: false,

      seatsSelectedRateGroupNew: [],
      totalAmountPrice: 0,
      totalSeatBooked: 0,
      totalNetAmout: 0,
      checkPopupExist: false,
      currencyData: [],
      searchCode: "",
      // CurrencyList: [
      //   {curr_id: '1', curr_code: "USD", curr_name: "US Dollar" },
      //   {curr_id: '2', curr_code: "IOD", curr_name: "Dinar" },
      //   {curr_id: '3', curr_code: "Franc", curr_name: "Swiss Franc" },
      // ],
      CurrencyList: [],
      CurrencyListCopy: [],
      searchCurrency: "",
      multiCurrencyModal: false,
      showCashCardPos: false,
      EjsData: null
    };
  },
  beforeMount() {
    this.accessLimitation = this.secureStore.get('BRUACS');
    this.roleid = this.secureStore.get("USINFO").role_id;
    this.cinema_id = this.secureStore.get("USINFO").cinema_id;
    this.reserveSeatsImmediate = this.secureStore.get("BGORST");
    this.getCountriesList();
    this.getCurrencyCode();
    // this.getCurrencyList();
    this.SetCinemaId({
      cinemaId: this.cinema_id,
      userDetails: null,
      stockDeduction: null,
      stockDeductionConcession: null,
    });
    // this.fetchFnBItems();
    this.paymentshowbutton = false;
    this.$store.dispatch("clearAllInput");
    EventBus.$on("checkPopupExist", (e) => {
      this.checkPopupExist = false;
    });
    if (this.cinema_id) {
      this.getCinemaDetails(this.cinema_id);
    }
  },
  mounted() {
     EventBus.$on("hidePosHiddenMenus", (data) => {
      this.posHiddenMenus = false;
    });
  },
  watch: {
    "$store.getters.booking_complete": function (newVal) {
      if (newVal) {
        if (this.SelectedFnbItemList && this.SelectedFnbItemList.length > 0) {
          this.showRefund("PosPackageFinalTicket");
        } else {
          this.showRefund("PosFinalTicket");
        }
      }
    },
    "$store.getters.topup_complete": function (newVal) {
      if (newVal) {
        this.showRefund("CashCardFinalPage");
      }
    },
    "$store.getters.reservationId": function (newVal, oldVal) {
      if (
        this.reserveSeatsImmediate === "N" ||
        this.isMultiSelectAllowed ||
        !this.isMultiSelectAllowed
      ) {
        //this.isMultiSelectAllowed ||
        if (String(newVal).length > 0) {
          if (this.boxOfficeFNBflag) {
            this.$router.push({
              path: "box-office-fnb",
            });
            setTimeout(() => {
              EventBus.$emit("startSeatRealeaseTimeBoxOffice", true);
            }, 1000);
            // this.section.seatLayout = false;
          } else {
            let checkFlag = this.secureStore.get("BGOPCP") || "N";
            if (checkFlag && checkFlag == "Y") {
              this.$refs.loyaltyMoadal.show();
            }
            this.paymentshowbutton = true;
            EventBus.$emit("startSeatRealeaseTimePOS", true);
            this.onClickSeat();
          }
        }
      }
    },
    "$store.getters.isOfferValidStatus": function (newVal, oldVal) {
      if (newVal) {
        this.makePayment();
      }
    },
    "$store.getters.isReservationDetailsAvailable": function (newVal, oldVal) {
      if (newVal) {
        this.isUnpaidBooking = true;
        this.paymentshowbutton = true;
        this.posHiddenMenus = !this.posHiddenMenus;
      }
    },
    "$store.getters.bookSeatsError": function (newVal) {
      console.log('COMING TO BOOK SEAT ERROR', newVal);
      if (newVal) {
        this.onClickBack();
      }
    },
    "section.seatLayout": function (newValue, oldValue) {
      console.log('WATCHER section.seatLayout', newValue, oldValue);
      if(!newValue) {
        this.checkoutBtndis = false;
      }
    },
    "section.movieDetail": function (newValue, oldValue) {
      console.log('WATCHER section.movieDetail', newValue, oldValue);
      if(newValue) {
         try {
          if (this.$socket) {
            console.log('EMITTING home_page');
            this.$socket.emit("home_page");
          }
        } catch (err) {
          console.log('Error:', err);
        }
      }
    },
    onClickYes: function (newVal, oldVal) {
      if (newVal) {
        this.makePayment();
      }
    },
  },
  computed: {
    GET_MERIT_GIFT_CARD_DETAILS() {
      return this.$store.getters.GET_MERIT_GIFT_CARD_DETAILS;
    },
    MeritCardAmount() {
      let amount = 0;
      let gc_details = this.$store.getters.GET_MERIT_GIFT_CARD_DETAILS;
      if(gc_details) {
        amount = +parseFloat(gc_details['amount']).toFixed(2)
      }
      return amount
    },
    MANAGER_AUTH_FOR_CHANGES() {
      return this.$store.getters.MANAGER_AUTH_FOR_CHANGES
    },
     USE_TIM_INTEGRATION() {
      return this.$store.getters.USE_TIM_INTEGRATION;
    },
     USE_NEOLEAP_POS_PAYMENT() {
      return this.$store.getters.USE_NEOLEAP_POS_PAYMENT;
    },
    paymentModesArray() {
      let paymentModesTemp = []
        this.paymentModes.map((x) => {
          x['keyboardActive'] = false;
            paymentModesTemp.push(x)
        })

      return paymentModesTemp
    },
    pos_final_page_standBy_time() {
      return parseInt(this.$store.getters.POS_FINAL_PAGE_STANDBY_TIME);
    },
    disableMenu() {
      if (
        this.section.checkout ||
        this.section.seatLayout ||
        this.section.cashCardTopup
      ) {
        return true;
      } else {
        return false;
      }
    },
    toPay() {
      let total =
        parseFloat(this.$store.getters.TOTAL_AMOUNT) -
        parseFloat(this.selectedFnBItemsTotalPrice) -
        parseFloat(this.TotalAdditionalTaxes) -
        parseFloat(this.$store.getters.getOfferPrice) -
        parseFloat(this.$store.getters.getloyaltyAmount) -
        parseFloat(this.$store.getters.paid_amount) +
        parseFloat(this.$store.getters.selectedAddonsTotalPrice);
      return total;
    },
    DirectPrint() {
      return this.$store.getters.DirectPrint;
    },
    isCashCardTransaction() {
      return this.$store.getters.isCashCardTransaction;
    },
    POS_AMOUNT_CALCULATION_CHECK() {
      return this.$store.getters.POS_AMOUNT_CALCULATION_CHECK;
    },
    noFnbItems() {
      if (parseInt(this.$store.getters.getFnbItemLength) == 0) {
        return true;
      } else {
        return false;
      }
    },
    getCustMobCode() {
      return this.$store.getters.getCustMobCode;
    },
    checkRateCardGroupExist() {
      return this.$store.getters.isGroupExist;
    },
    checkCompleteRateCard() {
      return this.$store.getters.isCompleteRateCard;
    },
    seatsSelectedRateGroup() {
      let array = [];
      if (this.checkPopupExist == false) {

        this.totalSeatBooked = 0;
        this.totalAmountPrice = 0;
        this.totalNetAmout = 0;
        let checkCheckoutRateCardNeeded = 0;
        if (this.$store.getters.SELECTED_SEATS.length > 0) {
          this.$store.getters.SELECTED_SEATS.map((x) => {
            let find_In = array.findIndex((new1) => {
              return new1.sst_id == x.sst_id;
            });

            if (find_In >= 0) {
              array[find_In]["AllSeats"].push(x);
              if (array[find_In]["rate_card_group"].length == 1) {
                array[find_In]["totalSelected"] =
                  array[find_In]["totalSelected"] + 1;
                array[find_In]["rate_card_group"][0].totalSeatSelected =
                  array[find_In]["rate_card_group"][0].totalSeatSelected + 1;
                // console.log(x.rc_total_amount, "test");
                this.totalAmountPrice =
                  parseFloat(this.totalAmountPrice) +
                  parseFloat(
                    array[find_In]["rate_card_group"][0].rc_total_amount
                  );
                this.totalNetAmout =
                  parseFloat(this.totalNetAmout) +
                  parseFloat(
                    array[find_In]["rate_card_group"][0].rc_net_amount
                  );
                this.totalSeatBooked = this.totalSeatBooked + 1;
              } else if (array[find_In]["rate_card_group"].length > 1) {
                let checkDefaultRateCardFindIndex=array[find_In]["rate_card_group"].findIndex(x=>{
                  return x.default_rate_card=='Y'
                });
                console.log(checkDefaultRateCardFindIndex,"checkDefaultRateCardFindIndex")
                checkCheckoutRateCardNeeded = checkCheckoutRateCardNeeded + 1;
                  if(array[find_In]["rate_card_group"][checkDefaultRateCardFindIndex].default_rate_card=='Y'){
                  array[find_In]["totalSelected"] =array[find_In]["totalSelected"] + 1 ;
                  array[find_In]["rate_card_group"][checkDefaultRateCardFindIndex].totalSeatSelected = array[find_In]["rate_card_group"][checkDefaultRateCardFindIndex].totalSeatSelected + 1;
                this.totalAmountPrice =
                  parseFloat(this.totalAmountPrice) +
                  parseFloat(array[find_In]["rate_card_group"][checkDefaultRateCardFindIndex].rc_total_amount);
                this.totalNetAmout =
                  parseFloat(this.totalNetAmout) +
                  parseFloat(array[find_In]["rate_card_group"][checkDefaultRateCardFindIndex].rc_net_amount);
                this.totalSeatBooked = this.totalSeatBooked + 1;

                }

              }else{
              }
            } else {
              let arrayCardGroup = [];
              x.rate_card_group.map((rg) => {
                rg["totalSeatSelected"] = 0;
                arrayCardGroup.push(rg);
              });
              let obj = {
                srt_name: x.sst_seat_type,
                sst_id: x.sst_id,
                AllSeats: [x],
                totalSelected: 0,
                rate_card_group: arrayCardGroup,
              };
              if (arrayCardGroup.length == 1) {
                obj["totalSelected"] = 1;
                obj["rate_card_group"][0].totalSeatSelected = 1;
                this.totalAmountPrice =
                  parseFloat(this.totalAmountPrice) +
                  parseFloat(obj["rate_card_group"][0].rc_total_amount);
                this.totalNetAmout =
                  parseFloat(this.totalNetAmout) +
                  parseFloat(obj["rate_card_group"][0].rc_net_amount);
                this.totalSeatBooked = this.totalSeatBooked + 1;
              } else if (arrayCardGroup.length > 1) {
                checkCheckoutRateCardNeeded = checkCheckoutRateCardNeeded + 1;
                 let checkDefaultRateCardFindIndex=obj["rate_card_group"].findIndex(x=>{
                  return x.default_rate_card=='Y'
                })
                if(obj["rate_card_group"][checkDefaultRateCardFindIndex].default_rate_card=='Y'){
                   obj["totalSelected"] = 1;
                obj["rate_card_group"][checkDefaultRateCardFindIndex].totalSeatSelected = 1;
                this.totalAmountPrice =
                  parseFloat(this.totalAmountPrice) +
                  parseFloat(obj["rate_card_group"][checkDefaultRateCardFindIndex].rc_total_amount);
                this.totalNetAmout =
                  parseFloat(this.totalNetAmout) +
                  parseFloat(obj["rate_card_group"][checkDefaultRateCardFindIndex].rc_net_amount);
                this.totalSeatBooked = this.totalSeatBooked + 1;

                }

              }

              array.push(obj);
            }
          });
          this.seatsSelectedRateGroupNew = array;
          let ttArray = [];

          if(this.seatsSelectedRateGroupNew.length > 0) {
            this.seatsSelectedRateGroupNew.forEach(async (screenSeatType) => {
              let defaultTicketType = screenSeatType.rate_card_group.find((x) => x.default_rate_card == 'Y')
              let ttId = defaultTicketType.tt_id;
              if(!ttArray.includes(ttId)) {
                console.log('coming onSetSelectedOfferId',ttId );
                await this.onSetSelectedOfferId({ name: "isTicketType", id: ttId });
                // await this.fetchOffersList({ tt_id: ttId });
                ttArray.push(ttId);
              }
            })
          }

          if (
            checkCheckoutRateCardNeeded == 0 &&
            array[0]["rate_card_group"].length > 0
          ) {
            console.log("Group Card Not Needed");
            this.$store.dispatch("onSetCompleteRateCard", {
              status: true,
              seatGroup: this.seatsSelectedRateGroupNew,
            });
            this.$store.dispatch("onSetCompleteNewTotalAmount", {
              totalAmount: this.totalAmountPrice,
              netAmount: this.totalNetAmout,
            });
          } else if (checkCheckoutRateCardNeeded > 0) {
            this.$store.dispatch("onSetCompleteRateCard", {
              status: false,
              seatGroup: this.seatsSelectedRateGroupNew,
            });
          }

          console.log(array);
          return array;
        } else {
          this.seatsSelectedRateGroupNew = [];
          return array;
        }
      } else {
        return this.seatsSelectedRateGroupNew;
      }
    },
    CashCardAmount() {
      return this.$store.getters.isCashCardDetail.hasOwnProperty("cardAmount")
        ? this.$store.getters.isCashCardDetail.cardAmount
        : 0;
    },
    isMultiSelectAllowed: {
      get() {
        return this.$store.getters.isMultiSelectAllowed;
      },
      set(value) {
        this.$store.dispatch("onChangeMultiSelectSwitch", value);
      },
    },
    input_number: {
      get() {
        return this.$store.getters.customer_mobile_number;
      },
      set(value) {
        this.$store.dispatch("updateCustomerMobileNumber", value);
      },
    },
    first_name: {
      get() {
        return this.$store.getters.first_name;
      },
      set(value) {
        this.$store.dispatch("updateCustomerDetails", {
          type: "fname",
          value: value,
        });
      },
    },
    last_name: {
      get() {
        return this.$store.getters.last_name;
      },
      set(value) {
        this.$store.dispatch("updateCustomerDetails", {
          type: "lname",
          value: value,
        });
      },
    },
    email_address: {
      get() {
        return this.$store.getters.email_address;
      },
      set(value) {
        this.$store.dispatch("updateCustomerDetails", {
          type: "email",
          value: value,
        });
      },
    },
    is_loyality_subscribe: {
      get() {
        return this.$store.getters.is_loyality_subscribe;
      },
      set(value) {
        this.$store.dispatch("updateCustomerDetails", {
          type: "is_loyality_subscribe",
          value: value,
        });
      },
    },
    total_payment() {
      return this.paymentModes.reduce(
        (acc, { amount }) => acc + parseFloat(amount),
        0
      );
    },
    balance_amount() {
      if (this.total_payment > 0) {
        return (
          this.totalAmount +
          parseInt(this.CashCardAmount) -
          this.getloyaltyAmount -
          this.getOfferPrice -
          this.total_payment
        );
      } else {
        return 0;
      }
    },
    cust_id() {
      return this.$store.getters.cust_id;
    },
    isOldCustomer() {
      return this.$store.getters.getIsOldCustomer;
    },
    isLoyaltyApplied() {
      return this.$store.getters.isLoyaltyApplied;
    },
    getloyaltyAmount() {
      return this.$store.getters.getloyaltyAmount;
    },
    isEdit() {
      return this.$store.getters.isEdit;
    },
    isSearch() {
      return this.$store.getters.isSearch;
    },
    totalNumberOfSeats() {
      return this.$store.getters.totalNumberOfSeats;
    },
    selectedSeats() {
      return this.$store.getters.SELECTED_SEATS;
    },
    userINFO() {
      return this.$store.getters.SHOW_USER_INFO;
    },
    cashInput() {
      return this.$store.getters.CASH_INPUT;
    },
    selectedDate() {
      return this.$store.getters.SELECTED_DATE;
    },
    scheduleShowId() {
      return this.$store.getters.SCHEDULE_SHOW_ID;
    },
    getOfferPrice() {
      return this.$store.getters.getOfferPrice;
    },
    isVipSeatSelected() {
      return this.$store.getters.isVipSeatSelected;
    },
    reservationId() {
      return this.$store.getters.reservationId;
    },
    selectedPaymentMode() {
      return this.$store.getters.selectedPaymentMode;
    },
    getcurrency() {
      return this.$store.getters.GET_CURRENCY;
    },

    seatsSelected() {
      // console.log('userdetails :', userdetails);
      if (this.userINFO && this.userINFO.length > 0) {
        let userdetails = this.userINFO[0];
        // console.log("userdetails :", userdetails);
        if (this.roleid != 1 && userdetails.cine_sell_fnb_in_boxoffice == "Y" && this.accessLimitation != 'POSONLY') {
          this.fnbactive = true;
        } else if (this.roleid == 1) {
          this.fnbactive = true;
        }
      }
      if (this.section.seatLayout) {
        this.showbutton = true;
      }
      return this.$store.getters.SELECTED_SEATS;
    },
    totalAmount() {
      return this.$store.getters.TOTAL_AMOUNT;
    },
    currentScreen() {
      return this.$store.getters.CURRENT_SCREEN;
    },
    getShowCashCardLogsModalStore() {
      return this.$store.getters.getShowCashCardLogsModal;
    },
    ...mapGetters([
      "getSelectedOffer",
      "CardNumber",
      "paymentModes",
      "usedCashCards",
      "cashCards",
      "getCashCardLogs",
      "getShowCashCardLogsModal",
      //
      "SHOW_USER_INFO",
      //
      "SelectedFnbItemList",
      "selectedFnBItemsTotalPrice",
      "TotalAdditionalTaxes",
      "getIsSplitUsingLoyaltyCashCard",
      "getCustomerDetails",
      "cust_id",
    ]),
  },
  methods: {
    // checkAuthManager(moduleName){
    //   this.authModuleName = moduleName
    //   if(this.MANAGER_AUTH_FOR_CHANGES == 'Y' && !this.noAuth) {
    //    this.$bvModal.show("authManagerLoginPopup");
    //   }
    //   else{
    //     this.noAuth = false;
    //     this.showRefund(moduleName)

    //   }
    // },
    onClickFooterBtn: _.debounce(function(menuName) {
      this.btnDisable = true;
      this.showRefund(menuName);
      setTimeout(() => {
        this.btnDisable = false;
      }, 1000);
    }, 200),
    onClickHardReload: _.debounce(function(menuName) {
      this.btnDisable = true;
      this.HARD_RELOAD_POS();
      setTimeout(() => {
        this.btnDisable = false;
      }, 1000);
    }, 200),
    OpenFooterMenu(menuName) {
      this.menuName = menuName
      this.managerAuthObj['moduleName'] = menuName;
      this.managerAuthObj['refName'] = menuName;

      if(this.MANAGER_AUTH_FOR_CHANGES == 'Y' && !this.noAuth) {
        console.log('COMING HERE ', menuName);
        this.$bvModal.show(menuName);
      } else {
        this.noAuth = false;
        this.$bvModal.hide(menuName);
        this.showRefund(menuName)
      }
    },
    onCheckAuthentication(response) {
      const {valid, name} = response
      if(valid) {
        // this.noAuth = true;
        this.$bvModal.hide(name);
        this.showRefund(name);
      }
    },
    onValidateAuth(valid) {
      if(valid) {

        this.noAuth = true;
        this.$bvModal.hide("authManagerLoginPopup");
        // this.checkAuthManager(this.authModuleName);
      }
    },
    onCloseKeyboard(pm) {
      pm['keyboardActive'] = false;
      this.$forceUpdate();
    },
    onClickShowKeyboard(pm) {
      this.paymentModesArray.map((x) => {
        if(pm.pm_id !== x.pm_id) {
          x['keyboardActive'] = false;
        }
      })

      pm['keyboardActive'] = true;
      this.$forceUpdate();
    },
    onClickInputHandler(pm) {
      if(this.paymentModesArray.some((y) => y.keyboardActive == true)) {
        this.paymentModesArray.map((x) => {
        if(pm.pm_id !== x.pm_id) {
          x['keyboardActive'] = false;
        }
      })
       pm['keyboardActive'] = !pm['keyboardActive'];
       this.$forceUpdate();
      }
    },
     onClickAddCustInputHandler(event) {
      if(Object.keys(this.keyboardsVisible).some((x) => this.keyboardsVisible[x] == true)) {
        Object.keys(this.keyboardsVisible).map((x) => {
          this.keyboardsVisible[x] = false;
        })
        this.keyboardsVisible[event] = true;
        this.$forceUpdate();
      }
    },
    printHandler(type) {
      this.$refs.testprintOptions.hide();

      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf(" electron/") > -1) {
        try {
          if (this.$socket) {
            this.$socket.emit("on_print_ticket", {
                baseurl: BASEURL,
                ttype: "test_print",
                cinema_id: this.cinema_id,
                type: type
              });
          }
        } catch (err) {
           console.log("Error:", err);
        }
      } else {
        this.printTest(type);
      }
    },
     printTest: function(type) {
       let loader = this.$loading.show()

      let payload = {
        cinema_id: this.cinema_id,
        type: type
      };

      MasterService.TestPrint(payload).then(response => {
        console.log("response :", response);

         if (response) {
        const { data } = response;

        this.EjsData = data;

        this.$nextTick(() => {
            loader.hide();
            const p = new Printd();
            if (this.$refs.onPrint && this.EjsData != null) {
              p.print(this.$refs.onPrint, []);
            }
          });
      }
      }).catch((err) => {
        console.log("Error:", err);
      }).finally(() => {
        loader.hide();
      })
    },
    onClickTestPrint() {
      this.$refs.testprintOptions.show();
    },
    away: function() {
      this.posHiddenMenus = false;
    },
     callClose: function() {

      this.$store.dispatch("onCloseClearIDsforBoxOffice");
      this.$store.dispatch("onCloseClearIDsforFnb");

      //   this.$store.dispatch("onResetDateStoreState");
      this.$store.dispatch("ResetAddonData");
      this.$store.dispatch("MAKE_DATA_EMPTY");

      this.$store.dispatch("onResetFnBStoreState");
       this.$store.dispatch("clearAllInput");

        this.onClickHandler('Refresh');
       this.paymentshowbutton = false;
      this.isUnpaidBooking = false;
      this.showbutton = false;
      this.$bvModal.hide('BookConfirmUnPaid')
        this.onClickCloseButton();


    },
    bookUnPaidBooking(){
      let cust_id=null

      if(this.cust_id){
        if(Array.isArray(this.cust_id)){
          cust_id=this.cust_id[0]
        }else {
          cust_id=this.cust_id
        }
      }
      let loader = this.$loading.show();
      let payload={"isGroupRateCard":true,"reservationId":this.reservationId,"customer_id":cust_id}

     PosService.GetReservationDetails(payload).then(async (response) => {
      const {data} = response;

      this.$bvModal.hide('bookUnpaidConfirm')

      if(data && data.status) {
        this.$bvModal.show('BookConfirmUnPaid')
      } else {
        this.$toasted.show(data.message || 'Unpaid Booking Failed')
        if(data.hasOwnProperty('seatRelease') && data.seatRelease) {
          await this.$store.commit("SET_EMPTY_SEAT_BOOKING_DETAILS");
          this.showRefund("Refresh");
        }
      }
    }).catch(error=>{
      console.log('Error:', error);
    }).finally(() => {
      loader.hide()
    })
    },
    onIdleCheckout() {
      console.log('Idle Time Out')
      this.showRefund("Refresh");
    },
    order(id) {
      if (
        this.$store.getters.getPosFooterMenus &&
        this.$store.getters.getPosFooterMenus.length > 0
      ) {
        let array = this.$store.getters.getPosFooterMenus.filter((x) => {
          return x.pfm_id == id;
        });
        if (array && array.length > 0) {
          return array[0].menu_order;
        } else {
          return 100;
        }
      } else {
        return 100;
      }
    },
    getCurrencyCode: function () {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id:
          this.secureStore.get("BRGLOPCU") &&
          this.secureStore.get("BRGLOPCU").go_value,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    getCurrencyList: function () {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.CurrencyList = data.Records;
            this.CurrencyListCopy = data.Records;
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("Catch Error :", error);
        });
    },
    onSearchCode() {
      if (this.searchCode && this.searchCode.length > 0) {
        this.Countries = this.CodeListCopy.filter((x) => {
          if (
            x.country_mob_code &&
            x.country_mob_code
              .toLowerCase()
              .includes(this.searchCode.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Countries = this.CodeListCopy;
      }
    },
    onChangePagination(event) {
      if (event === undefined) {
        this.currentPage = 1;
      } else {
        this.currentPage = event;
      }
      this.getCashCardTransactionLogs({
        cash_card_id: this.CashCardDetail.cash_card_id,
        currentPage: this.currentPage,
        perPage: this.perPage,
      });
    },
    RateCardSubmit(type) {
      this.$store.dispatch("onSetCompleteRateCard", {
        status: true,
        seatGroup: this.seatsSelectedRateGroupNew,
      });
      this.$store.dispatch("onSetCompleteNewTotalAmount", {
        totalAmount: this.totalAmountPrice,
        netAmount: this.totalNetAmout,
      });
      this.$store.dispatch("COMPUTE_NEW_SEAT_LAYOUT", {
        seat_layout_id: this.$store.getters.SELECTED_SEATS,
        seatGroup: this.seatsSelectedRateGroupNew,
        showDetails: this.$store.getters.SHOW_DETAILS,
      });

      setTimeout((x) => {
        if (type) {
          this.onClickProceed(type);
        } else {
          this.onClickProceed();
        }

        this.$refs.showRateCardPrice.hide();
      }, 300);
    },
    async totalCount(rg, index, rg_index, type) {
      console.log(this.seatsSelectedRateGroupNew);
      let x =
        this.seatsSelectedRateGroupNew[index]["rate_card_group"][rg_index];

      await this.onSetSelectedOfferId({ name: "isTicketType", id: x["tt_id"] });
      // await this.fetchOffersList({ tt_id: x["tt_id"] });
      if (
        type == "increment" &&
        this.seatsSelectedRateGroupNew[index].totalSelected ==
          this.seatsSelectedRateGroupNew[index].AllSeats.length
      ) {
        return false;
      }

      if (
        type == "increment" &&
        this.totalSeatBooked + 1 <= this.$store.getters.SELECTED_SEATS.length &&
        x["totalSeatSelected"] <= this.$store.getters.SELECTED_SEATS.length
      ) {
        x["totalSeatSelected"] = x["totalSeatSelected"] + 1;
        this.seatsSelectedRateGroupNew[index].totalSelected =
          this.seatsSelectedRateGroupNew[index].totalSelected + 1;
      } else if (
        this.seatsSelectedRateGroupNew[index].totalSelected >= 1 &&
        type == "decrement" &&
        x["totalSeatSelected"] >= 1
      ) {
        x["totalSeatSelected"] = x["totalSeatSelected"] - 1;
        this.seatsSelectedRateGroupNew[index].totalSelected =
          this.seatsSelectedRateGroupNew[index].totalSelected - 1;
      }

      let totalAmount = 0;
      let totalSeatBooked2 = 0;
      let totalNetAmout2 = 0;
      this.seatsSelectedRateGroupNew.map((z) => {
        z.rate_card_group.map((y) => {
          totalAmount =
            parseFloat(totalAmount) +
            parseFloat(y.totalSeatSelected) * parseFloat(y.rc_total_amount);

          totalNetAmout2 =
            parseFloat(totalNetAmout2) +
            parseFloat(y.totalSeatSelected) * parseFloat(y.rc_net_amount);
        });

        totalSeatBooked2 =
          parseInt(totalSeatBooked2) + parseInt(z.totalSelected);
      });
      this.totalAmountPrice = totalAmount;
      this.totalSeatBooked = totalSeatBooked2;
      this.totalNetAmout = totalNetAmout2;
      x["tt_name"] = x["tt_name"] + " ";
      if (totalSeatBooked2 == this.$store.getters.SELECTED_SEATS.length) {
        // this.$store.dispatch("onSetCompleteRateCard", {
        //   status: true,
        //   seatGroup: this.seatsSelectedRateGroupNew,
        // });
        // this.$store.dispatch("onSetCompleteNewTotalAmount", {
        //   totalAmount: this.totalAmountPrice,
        //   netAmount: this.totalNetAmout,
        // });
      } else {
        this.$store.dispatch("onSetCompleteRateCard", {
          status: false,
          seatGroup: this.seatsSelectedRateGroupNew,
        });
      }
      console.log("fdsfdsfdsf");
    },
    onClickViewTransactions() {
      if (this.CashCardDetail.cash_card_id) {
        this.getCashCardTransactionLogs({
          cash_card_id: this.CashCardDetail.cash_card_id,
          currentPage: this.currentPage,
          perPage: this.perPage,
        });
        this.$refs.cashCard.hide();
        this.$refs.cashCardLogs.show();
      }
    },
    selectCashCard(card) {
      console.log(card, "fsdfds");
      if (card.cash_card_number != "Add New Card") {
        this.CashCardDetail.cash_card_id = card.cash_card_id;
        this.CashCardDetail.cardNumber = card.cash_card_number;
        this.cashCardNewInput = false;
        this.cashCardNumberNewValue = "";
      } else {
        this.CashCardDetail.cardNumber = "Add New Card";
        this.cashCardNewInput = true;
        this.CashCardDetail.cash_card_id = "";
      }
    },
    selectCustomer(customer) {
      this.CashCardDetail.customer_name = `${customer.first_name} ${customer.last_name}`;
      this.CashCardDetail.customer = customer;
    },
    showCashCard() {
      if (this.isOldCustomer) {
        this.$refs.cashCard.show();
      } else {
        this.$refs.loyaltyMoadal.show();
      }
    },
    AddCashCard() {
      if (
        Math.sign(this.CashCardDetail.cardNumber) === -1 ||
        Math.sign(this.CashCardDetail.cardAmount) === -1
      ) {
        this.$toasted.show("Please enter only positive numbers.");
        return;
      }
      if (this.CashCardDetail.cardNumber == "") {
        this.$toasted.show("Please select card number. ");
        return false;
      } else if (this.cashCardNewInput && this.cashCardNumberNewValue == "") {
        if (Math.sign(this.cashCardNumberNewValue) === -1) {
          this.$toasted.show("Please enter only positive numbers.");
          return;
        }
        this.$toasted.show("Please enter card number. ");
        return false;
      } else if (this.CashCardDetail.cardAmount == "") {
        this.$toasted.show("Please enter card amount. ");
        return false;
      }

      if (this.cashCardNewInput) {
        let checkFilter = this.cashCards.filter((x) => {
          return x.cash_card_number == this.cashCardNumberNewValue;
        });
        if (checkFilter.length > 0) {
          this.CashCardDetail.cash_card_id = checkFilter[0].cash_card_id;
          this.cashCardNumberNewValue = "";
        } else {
          this.CashCardDetail.cash_card_id = "";
        }
      }

      let payload = {
        ...this.CashCardDetail,
        newCashCardValue: this.cashCardNumberNewValue,
      };

      this.$store.dispatch("onChangeAddCardDetail", payload);
      this.$refs.cashCard.hide();
      this.$toasted.show("Card Added Successfully. ");
      // this.checkoutOnlyCashCard = true;
      this.CashCardDetail = {
        cash_card_id: "",
        cardNumber: "",
        cardAmount: "",
      };
      this.cashCardNewInput = false;
    },
    checkTopUpCashInput() {
      if (
        this.selectedPaymentMode.pm_id == 2 ||
        this.selectedPaymentMode.pm_id == 3
      ) {
        this.onTopUpCashCard();
      } else if (this.selectedPaymentMode.pm_id == 1) {
        if (this.POS_AMOUNT_CALCULATION_CHECK == "N") {
          this.onTopUpCashCard();
        } else if (
          parseFloat(this.$store.getters.CASH_INPUT) >=
          this.$store.getters.getcashInputForCashCard
        ) {
          this.onTopUpCashCard();
        } else {
          this.$toasted.show("Cash Input is less then Total Amount");
        }
      } else {
        this.$toasted.show("Please Select a Active Payment Mode");
      }
    },
    onClickCloseCashCardLogs() {
      this.$refs.cashCardLogs.hide();
    },
    ...mapActions([
      "SET_CASH_INPUT",
      "getCinemaDetails",
      "onChangePaymentValue",
      "setIsSplitUsingLoyaltyCashCard",
      "getCashCardTransactionLogs",
      "updateCashCardAmount",
      "fetchOffersList",
      "fetchOffersVouchersList",
      "onSetSelectedOfferId",
      "fetchFnBItems",
      "SetCinemaId",
      "onTopUpCashCard",
      "HARD_RELOAD_POS",
    ]),
    isMenuActive(id) {
      return true;
      if (
        this.$store.getters.getPosFooterMenus &&
        this.$store.getters.getPosFooterMenus.length > 0
      ) {
        let array = this.$store.getters.getPosFooterMenus.filter((x) => {
          return x.pfm_id == id && x.menu_is_active == "Y";
        });
        if (array && array.length > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    onSelectHandler: function (value) {
      this.SelectedCountryCode = value.country_mob_code;
      this.$store.dispatch("updateCountryMobCode", value.country_mob_code);
    },
    getCountriesList: function () {
      this.Countries = [];
      let body = this.getRequestBody("GET", undefined, this.CountriesMethod);
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Countries = data.Records;
            this.CodeListCopy = data.Records;


             let defaultCon = data.Records.filter( c => {
              return c.country_mob_code == '966'
            })

            if(defaultCon.length > 0) {
              this.onSelectHandler(defaultCon[0])
            }

          } else {
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error :", error);
        });
    },
    onResetLoyalty() {
      this.$store.dispatch("resetLoyaltyData");
    },
    clearInput: function () {
      this.input_number = "";
    },
    onClicknumber: function (index) {
      this.input_number += this.phone_value[index].name;
    },
    onEditPhoneNumber: function () {
      this.$store.dispatch("onEditPhoneNumber");
    },
    onClickDelete: function () {
      this.$store.dispatch("clearAllInput");
    },
    onUpdateCustomerDetails() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          if (!this.getCustMobCode) {
            this.$toasted.show("Please Select Country Code.");
          } else if (this.input_number.length == 0) {
            this.$toasted.show("Please enter Mobile Number.");
          } else if (this.getCustMobCode && this.input_number.length > 0) {
            this.$store.dispatch("updateCustomerData", {
              first_name: this.first_name,
              last_name: this.last_name,
              mobile_number: this.input_number,
              cust_email: this.email_address,
              cust_id: this.cust_id,
              country_mob_code: this.getCustMobCode,
              is_loyality_subscribe: this.is_loyality_subscribe
            });
          }
        }
      });
    },
    onSaveDetails() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          if (!this.getCustMobCode) {
            this.$toasted.show("Please Select Country Code.");
          } else if (this.input_number.length == 0) {
            this.$toasted.show("Please enter Mobile Number.");
          } else if (this.getCustMobCode && this.input_number.length > 0) {
            this.$store.dispatch("updateOnlyCustomerDetails", {
              first_name: this.first_name,
              last_name: this.last_name,
              mobile_number: this.input_number,
              cust_email: this.email_address,
              cust_id: this.cust_id,
              setOnlyUser: true,
              country_mob_code: this.getCustMobCode,
              is_loyality_subscribe: this.is_loyality_subscribe
            })
            .then(status => {
              if (status && this.cust_id && this.selectedPaymentMode.pm_id == 17) {
                this.$bvModal.show('bookUnpaidConfirm')
              }
            });
          }
        }
      });
    },
    onSearch: function () {
      if (!this.getCustMobCode) {
        this.$toasted.show("Please Select Country Code.");
      } else if (this.input_number.length == 0) {
        this.$toasted.show("Please enter Mobile Number.");
      } else if (this.getCustMobCode && this.input_number.length > 0) {
        this.$store.dispatch("setUserDeatils", {
          sb_mobile_number: this.input_number,
          // onlySetUser: true,
          check_mob_code: true,
          country_mob_code: this.getCustMobCode,
        })
        .then(status => {
          if (status && this.cust_id && this.selectedPaymentMode.pm_id == 17) {
            this.$bvModal.show('bookUnpaidConfirm')
          }
        });
      }
      // SendSmS Service
    },
    gotoRoute: function (route) {
      this.$router.push({
        path: "pos-occupancy",
      });
    },
    onSliceNUmber: function () {
      if (!this.isEdit) {
        this.$store.dispatch("sliceNumber");
      }
    },
    onClickCancel: async function () {
      this.isUnpaidBooking = false;
      this.paymentshowbutton = false;
      await this.onUnpaidBookingCancel();
      // await this.onBackHandler();

      await this.$store.dispatch("Remove_Reservation_details");
    },
    onClickBack: function () {
      this.$store.dispatch("clearAllInput");
      if (this.section.seatLayout) {
        this.onBackHandler();

        this.showbutton = false;
        this.isUnpaidBooking = false;
        this.showRefund("Refresh");
        this.$store.dispatch("releaseRealtimeSeats");
        this.$store.dispatch("ResetVoucherCode");
        this.$store.dispatch("MAKE_DATA_EMPTY");
        this.$store.dispatch("CLEAR_CARD_NUMBER", null);
        this.$store.dispatch("onResetFnBStoreState");
        try {
          if (this.$socket) {
            this.$socket.emit("home_page");
          }
        } catch (err) {}
      } else if (this.section.checkout) {
        // this.$store.dispatch("RELEASE_SEATS");
        this.onBackHandler();
        this.paymentshowbutton = false;
        this.isUnpaidBooking = false;
        this.$store.dispatch("MAKE_SEAT_BOOKING_DETAILS_EMPTY");
        this.$store.dispatch("onResetFnBStoreState");
        this.$store.dispatch("ResetVoucherCode");
        this.$store.dispatch("CLEAR_CARD_NUMBER", null);
      } else if (this.section.movieDetail) {
        this.onBackHandler();
        this.showbutton = false;
        this.isUnpaidBooking = false;
        this.$store.dispatch("MAKE_SEAT_BOOKING_DETAILS_EMPTY");
        this.$store.dispatch("onResetFnBStoreState");
      } else {
        this.onBackHandler();
        this.showbutton = false;
        this.isUnpaidBooking = false;
        this.paymentshowbutton = false;
      }
      // this.$store.dispatch("MAKE_DATA_EMPTY");
      // this.onBackHandler();
      // this.showbutton = false;
      // this.paymentshowbutton = false;
    },
    showHiddenMenus: function () {
      this.posHiddenMenus = !this.posHiddenMenus;
    },
    showRefund: function (name) {
      if (name == "Refresh") {
        this.showbutton = false;
        this.paymentshowbutton = false;
        try {
          if (this.$socket) {
            this.$socket.emit("home_page");
          }
        } catch (err) {}
      }
      // if (name == "PosSchedule") {
      //   this.$store.dispatch("GET_SEATS_OCCUPANCY", {
      //     selectedDate: this.$store.getters.SELECTED_DATE,
      //     screen_id: this.$store.getters.CURRENT_SCREEN || null,
      //     cinema_id: this.cinema_id,
      //   });
      // }
      if (name == "Swap") {
          let pm_object = {
            pm_id: 1,
            pm_payment_mode: "Cash",
          };
          // this.$toasted.show("Please pay using Cash/Online payment");
          this.$store.dispatch("setPaymentMode", pm_object);
      }
      this.onClickHandler(name);
    },



    onClickCheckout: async function () {
      // console.log("this.selectedPaymentMode :", this.getSelectedOffer);
      if (this.selectedPaymentMode && this.selectedPaymentMode.pm_id == 1) {
        if (!this.usedCashCards || this.usedCashCards.length == 0) {
          if (
            this.getSelectedOffer &&
            this.getSelectedOffer.offer_type_id == 5 &&
            this.CardNumber != null
          ) {
            this.$toasted.show(
              "This offer is valid only for Credit/Debit Card payment."
            );
          } else {
            if (this.POS_AMOUNT_CALCULATION_CHECK == "N") {
              this.SET_CASH_INPUT(this.toPay);
              this.makePayment();
            } else if (
              parseFloat(this.$store.getters.CASH_INPUT) >=
                parseFloat(this.$store.getters.TOTAL_AMOUNT) +
                  parseFloat(this.selectedFnBItemsTotalPrice) +
                  parseFloat(this.TotalAdditionalTaxes) -
                  parseFloat(this.$store.getters.getOfferPrice) -
                  parseFloat(this.MeritCardAmount) -
                  parseFloat(this.$store.getters.getloyaltyAmount) -
                  parseFloat(this.$store.getters.paid_amount) +
                  parseFloat(this.$store.getters.selectedAddonsTotalPrice) &&
              !this.$store.getters.isSwap
            ) {
              this.makePayment();
            } else if (
              parseFloat(this.$store.getters.CASH_INPUT) >=
                parseFloat(this.$store.getters.TOTAL_AMOUNT) +
                  parseFloat(this.selectedFnBItemsTotalPrice) +
                  parseFloat(this.TotalAdditionalTaxes) -
                  parseFloat(this.MeritCardAmount) -
                  parseFloat(this.$store.getters.getOfferPrice) -
                  parseFloat(this.$store.getters.getloyaltyAmount) -
                  parseFloat(this.$store.getters.paid_amount) +
                  parseFloat(this.$store.getters.selectedAddonsTotalPrice) -
                  parseFloat(this.$store.getters.getSwapTotalAmount) &&
              this.$store.getters.isSwap
            ) {
              this.makePayment();
            } else {
              this.$toasted.show("Cash Input is less then Total Amount");
            }
          }
        } else {
          this.$toasted.show(
            "Please pay the remaining amount through split payment!"
          );
        }
      } else if (this.selectedPaymentMode.pm_id == 11) {
        if (
          parseFloat(this.$store.getters.paid_amount) >=
            parseFloat(this.$store.getters.TOTAL_AMOUNT) +
              parseFloat(this.selectedFnBItemsTotalPrice) +
              parseFloat(this.TotalAdditionalTaxes) -
              parseFloat(this.$store.getters.getOfferPrice) -
              parseFloat(this.$store.getters.getloyaltyAmount) +
              parseFloat(this.$store.getters.selectedAddonsTotalPrice) &&
          this.$store.getters.isCashCardTransaction == true
        ) {
          this.makePayment();
        } else {
          console.log("Amount is lesser for some reason");
          let pm_object = {
            pm_id: 1,
            pm_payment_mode: "Cash",
          };
          this.$toasted.show("Please pay using Cash/Online payment");
          this.$store.dispatch("setPaymentMode", pm_object);
          // this.$toasted.show("Please Complete payment");
        }
      } else if (
        this.selectedPaymentMode.pm_id == 10 ||
        this.selectedPaymentMode.pm_id == 12 ||
        this.selectedPaymentMode.pm_id == 13 ||
        this.selectedPaymentMode.pm_id == 23
      ) {
        console.log("this.selectedPaymentMode", this.selectedPaymentMode);
        if (
          parseFloat(this.$store.getters.CASH_INPUT) >=
          parseFloat(this.$store.getters.TOTAL_AMOUNT) -
            parseFloat(this.selectedFnBItemsTotalPrice) -
            parseFloat(this.TotalAdditionalTaxes) -
            parseFloat(this.$store.getters.getOfferPrice) -
            parseFloat(this.$store.getters.getloyaltyAmount) -
            parseFloat(this.MeritCardAmount || 0) -
            parseFloat(this.$store.getters.paid_amount) +
            parseFloat(this.$store.getters.selectedAddonsTotalPrice) -
            parseFloat(this.$store.getters.getSwapTotalAmount)
        ) {
          this.makePayment();
        } else {
          let pm_object = {
            pm_id: 1,
            pm_payment_mode: "Cash",
          };
          this.$toasted.show("Please pay using Cash/Online payment");
          this.$store.dispatch("setPaymentMode", pm_object);
        }
      } else if (
        (this.selectedPaymentMode.pm_id == 2 ||
          this.selectedPaymentMode.pm_id == 3) &&
        this.getSelectedOffer &&
        Object.keys(this.getSelectedOffer).length > 0 &&
        this.getSelectedOffer.offer_type_id == 5
      ) {
        if (!this.usedCashCards || this.usedCashCards.length == 0) {
          // if (
          //   this.getSelectedOffer &&
          //   this.getSelectedOffer.offer_type_id == 5 &&
          //   this.CardNumber != null
          // ) {
          await this.$store.dispatch("VerifyCardDetails", {
            reservation_id: this.reservationId,
            SelectedOffer: this.getSelectedOffer,
            Card_Number: this.CardNumber,
          });
          // } else {
          //   this.$toasted.show("Please enter card number for this offer");
          // }
        } else {
          this.$toasted.show(
            "Please pay the remaining amount through split payment!"
          );
        }
      } else if (
        (this.selectedPaymentMode.pm_id == 2 ||
          this.selectedPaymentMode.pm_id == 3) &&
        this.getSelectedOffer &&
        Object.keys(this.getSelectedOffer).length == 0
      ) {
        if (!this.usedCashCards || this.usedCashCards.length == 0) {
          this.makePayment();
        } else {
          this.$toasted.show(
            "Please pay the remaining amount through split payment!"
          );
        }
      } else  if (
        this.selectedPaymentMode.pm_id == 17
      ){
        // alert("Please Do Unpaid booking")
        if (this.cust_id) {
          this.$bvModal.show('bookUnpaidConfirm')
        } else {
          this.$refs.loyaltyMoadal.show();
          this.$toasted.show("Please add customer detail for Unpaid Booking");
        }
      }else{
        if (!this.usedCashCards || this.usedCashCards.length == 0) {
          this.makePayment();
        } else {
          this.$toasted.show(
            "Please pay the remaining amount through split payment!"
          );
        }
      }
      //
    },
    checkPaymentMode_onApplyingOffer() {
      if(
        this.selectedPaymentMode.pm_id == 10 ||
        this.selectedPaymentMode.pm_id == 12 ||
        this.selectedPaymentMode.pm_id == 13
        ) {
          let totalAmountToPay = (parseFloat(this.$store.getters.TOTAL_AMOUNT) +
            parseFloat(this.selectedFnBItemsTotalPrice) +
            parseFloat(this.TotalAdditionalTaxes) +
            parseFloat(this.$store.getters.selectedAddonsTotalPrice) -
            parseFloat(this.$store.getters.getSwapTotalAmount))

          if(
            totalAmountToPay >
            parseFloat(this.$store.getters.getOfferPrice)
          ) {
            let pm_object = {
              pm_id: 1,
              pm_payment_mode: "Cash",
            };
            this.$store.dispatch("setPaymentMode", pm_object);
          }
        }
    },
    makePayment() {
      this.paymentshowbutton = false;
      this.isUnpaidBooking = false;
      this.showbutton = false;
      const { user_id, cinema_id } = this.secureStore.get("USINFO");
      // this.$store.dispatch("GET_HARDWARE_NAME", user_id);
      // this.$store.dispatch("BOOK_SEATS", this.reservationId);
      this.checkPaymentMode_onApplyingOffer();
      if (this.SelectedFnbItemList && this.SelectedFnbItemList.length > 0) {
        this.$store.dispatch("onBoxOfficeAndFnBOrderSubmit", {
          isPackageTicket: true,
          cinema_id,
          currency_id:
            this.SHOW_USER_INFO && this.SHOW_USER_INFO.length > 0
              ? this.SHOW_USER_INFO[0].currency_id
              : null,
        });
      } else {
        this.$store.dispatch("insertBoxOfficeTransaction", {
          reservationId: this.reservationId,
        });
      }
      // this.$store.dispatch("NEW_ADDITIONAL_CHARGES");
      // this.showRefund("PosFinalTicket");
    },
    onSelectFnb: function () {
      let userInfo = this.secureStore.get("USINFO");
      userInfo["role_name"] = "Box Office Fnb";

      this.secureStore.set("USINFO", userInfo);
      this.$store.commit("SET_BO_FNB_SELECTED", true);
      // this.$store.dispatch("GET_ADDITIONAL_CHARGES", {
      //   selected_seats: this.$store.getters.SELECTED_SEATS,
      //   showDetails: this.$store.getters.SHOW_DETAILS,
      // });
      this.$store.dispatch("RESERVE_SEATS", {
        seat_layout_id: this.$store.getters.SELECTED_SEATS,
        schedule_show_id: this.scheduleShowId,
        reservation_id: Math.floor(100000000 + Math.random() * 900000000),
        seatGroup: this.seatsSelectedRateGroupNew,
        showDetails: this.$store.getters.SHOW_DETAILS,
      });

      this.boxOfficeFNBflag = true;
      this.$store.dispatch("OnPOSLogin", true);
      // this.$router.push({
      //   path: "box-office-fnb"
      // });
      // this.section.seatLayout = false;
    },
      onLogout: function() {
      UserService.removeToken()
        .then(res => {
          const { data } = res;
          if (data.status == true) {
            window.localStorage.removeItem("JWT_TOKEN");
            window.localStorage.clear();
            this.$router.push({ path: "/pos-login" });
            this.$cookie.delete("BRHSID");
          } else {
            window.localStorage.removeItem("JWT_TOKEN");
            window.localStorage.clear();
            this.$router.push({ path: "/pos-login" });
            this.$cookie.delete("BRHSID");
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          this.$router.push({ path: "/pos-login" });
          this.$toasted.show("Token not removed");
        });
    },
    reserveSeats: async function () {
      this.$refs.multiSeatsModal.hide();
      // this.paymentshowbutton = true;
      // this.$store.dispatch("GET_ADDITIONAL_CHARGES", {
      //   selected_seats: this.$store.getters.SELECTED_SEATS,
      //   showDetails: this.$store.getters.SHOW_DETAILS,
      // });

      let cinemaId = this.$store.getters.SHOW_DETAILS.cine_id;
      if(this.validateShowCinema(cinemaId)) {
      console.log('this.$store.getters.SHOW_DETAILS INSDIDE RESERVE SEATS', this.$store.getters.SHOW_DETAILS);

      await this.$store.dispatch("RESERVE_SEATS", {
        seat_layout_id: this.$store.getters.SELECTED_SEATS,
        schedule_show_id: this.scheduleShowId,
        reservation_id: Math.floor(100000000 + Math.random() * 900000000),
        seatGroup: this.seatsSelectedRateGroupNew,
        showDetails: this.$store.getters.SHOW_DETAILS,
      });

      // try {
      //   if (this.$socket) {
      //     this.$socket.emit("home_page");
      //   }
      // } catch (err) {}

      // this.$refs.loyaltyMoadal.show();

      this.$store.dispatch("CHANGE_FLAG_ShowViewOffers", false);
      } else {
        this.$toasted.show('Token Expired')
        this.onLogout();
      }
    },

    proceedtoCheckout() {
      this.paymentshowbutton = true;
      this.$store.dispatch("GET_PAYMENT_MODES", 1);
      this.$store.dispatch("GET_ADDITIONAL_CHARGES", {
        selected_seats: this.$store.getters.SELECTED_SEATS,
        showDetails: this.$store.getters.SHOW_DETAILS,
      });
      this.$store.dispatch("CHANGE_FLAG_ShowViewOffers", false);
      if (this.isFnbSelected) {
        let userInfo = this.secureStore.get("USINFO");
        userInfo["role_name"] = "Box Office Fnb";

        this.secureStore.set("USINFO", userInfo);
        this.$router.push({
          path: "box-office-fnb",
        });
      } else {
        this.section.seatLayout = false;
        this.onClickSeat();
        let checkPopUpFlag = this.secureStore.get("BGOPCP") || "N";
        if (checkPopUpFlag && checkPopUpFlag == "Y") {
          this.$refs.loyaltyMoadal.show();
        }
      }
    },

    CheckLogin() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          let payload = {
            username: this.username,
            password: this.password,
          };
          PosService.CheckCinemaManagerAuth(payload).then((response) => {
            const { data } = response;
            if (data.status) {
              this.username = "";
              this.password = "";
              this.$store.dispatch("SetApproverId", data.user_id);
              this.$refs.cinemaManagerLoginPopup.hide();
              if (this.isFnbSelected) {
                this.onSelectFnb();
              } else {
                this.reserveSeats();
              }
            } else {
              this.$toasted.show(
                data.message ||
                  "Sorry! Something went wrong. kindly contact your administrator"
              );
            }
          });
        }
      });
    },

    onClickProceed: async function (type) {
      // console.log("fsdfdsf");
      await this.fetchOffersList()
      await this.fetchOffersVouchersList()
      let value = this.secureStore.get("BGORST");
      this.isFnbSelected = type == "isFnb" ? true : false;
      // console.log(this.seatsSelected);
      // return false;

      if (this.isVipSeatSelected) {
        if (this.checkCompleteRateCard == false) {
          this.checkPopupExist = true;
          this.$refs.showRateCardPrice.show();
        } else {
          this.$refs.cinemaManagerLoginPopup.show();
        }
      } else if (this.seatsSelected.length < this.totalNumberOfSeats) {
        this.$refs.multiSeatsModal.show();
      } else if (type == "isFnb") {
        //this.isMultiSelectAllowed ||
        if (this.checkRateCardGroupExist) {
          if (this.checkCompleteRateCard == false) {
            this.checkPopupExist = true;
            this.$refs.showRateCardPrice.show();
          } else {
            this.$refs.multiSeatsModal.hide();
            this.checkoutBtndis = true
            this.onSelectFnb();
          }
          // this.$refs.showRateCardPrice.show();
          // console.log(filter_new);
        } else {
          this.$refs.multiSeatsModal.hide();
          this.checkoutBtndis = true
          this.onSelectFnb();
        }
      } else if (
        this.isMultiSelectAllowed ||
        (value && value === "N") ||
        !this.isMultiSelectAllowed
      ) {
        console.log("fsdfdsf3");
        //this.isMultiSelectAllowed ||

        this.$refs.multiSeatsModal.hide();
        let filter_new = this.seatsSelected.filter((x) => {
          return x.rate_card_group.length > 0;
        });
        if (this.checkRateCardGroupExist) {
          console.log("fsdfdsf33");

          if (this.checkCompleteRateCard == false) {
            this.checkPopupExist = true;
            console.log("fsdfdsf33333344");
            this.$refs.showRateCardPrice.show();
          } else {
            console.log("fsdfdsf3333");
            this.checkoutBtndis = true
            this.reserveSeats();
          }

          console.log(filter_new);
        } else {
          this.checkoutBtndis = true
          this.reserveSeats();
          console.log("fsdfdsf333334555333");
        }

        // this.$store.dispatch("VerifyCardDetails", { reservation_id: this.reservationId, SelectedOffer: this.getSelectedOffer, Card_Number: this.CardNumber })
      } else {
        console.log("fsdfdsf33333455333345333");
        this.checkoutBtndis = true
        this.proceedtoCheckout();
      }
      // this.fnbactive = false;
      // this.onClickSeat();
    },
    onCancelHandler: function () {
      this.$store.dispatch("onCancelSelectedSeatsHandler");
      this.$store.dispatch("onResetFnBStoreState");
    },
    // onChangePayment: function(index, value) {

    //   this.paymentModes[index].amount =
    //     value && value.length > 0 && value.replace(/\s/g, "").length > 0
    //       ? parseFloat(value)
    //       : 0;
    //   if (this.total_payment > this.totalAmount) {
    //     this.$toasted.show("Payment Value cannot be greater than Total Amount");
    //   }
    // },
    onPayViaSplitMethod() {
      if (
        parseFloat(this.total_payment).toFixed(2) ==
        parseFloat(
          this.totalAmount -
            this.getOfferPrice -
            this.getloyaltyAmount +
            parseFloat(this.CashCardAmount)
        ).toFixed(2)
      ) {
        this.$refs["splitPayments"].hide();
        const splitLoyaltyAmount = this.paymentModes.find(
          (mode) => mode.pm_payment_mode === "Loyalty"
        );
        console.log(
          "🚀 ~ file: posFooter.vue ~ line 2687 ~ onPayViaSplitMethod ~ splitLoyaltyAmount",
          splitLoyaltyAmount
        );
        const splitCashCardAmount = this.paymentModes.find(
          (mode) => mode.pm_payment_mode === "Cash Card"
        );
        console.log(
          "🚀 ~ file: posFooter.vue ~ line 2691 ~ onPayViaSplitMethod ~ splitCashCardAmount",
          splitCashCardAmount
        );

        // if (splitLoyaltyAmount.amount > 0 || splitCashCardAmount.amount > 0) {
        if (Object.keys(this.getCustomerDetails).length === 0) {
          this.$refs.loyaltyMoadal.show();
          this.setIsSplitUsingLoyaltyCashCard(true);
        } else if (
          Object.keys(this.getCustomerDetails).length > 0 &&
          this.getCustomerDetails.points > this.total_payment
        ) {
          this.paymentshowbutton = false;
          this.isUnpaidBooking = false;
          this.showbutton = false;
          const { user_id } = this.secureStore.get("USINFO");
          this.$store.dispatch("insertBoxOfficeTransaction", {
            reservationId: this.reservationId,
            isSplitPayment: true,
          });
        }
        // }
      } else {
        this.$toasted.show("Payment Value is not same as Total Amount");
      }
    },
    hideCashCardPos() {
      this.showCashCardPos = false;
    },
  },
};
</script>

<style scoped>
/*@media (min-width: 992px) {*/

/* .seat_select_modal .modal-lg{*/
/*  max-width: 1030px;*/
/*  background-color: white;*/
/*  } */

/*}*/

.seat-type {
  padding: 1rem;
  min-width: 200px;
  height: 115px;
  font-weight: bold;
}

#showRateCardPrice .seat-type {
  /* width: 280px !important; */
  width: 230px !important;
}

.seat-type.gold {
  background-color: #fcf4d9;
  color: #f2c94c;
}

.seat-type.silver {
  background-color: #efefef;
  color: #a8a8a8;
}

.seat-type .st-name {
  font-weight: bold;
  /* font-size: 2.5rem; */
  font-size: 2rem;
  border-bottom: 1px solid #bfbfbf;
  line-height: 1;
  margin-bottom: 0.25rem;
  word-break: break-all;
}
#showRateCardPrice .category {
  width: 230px !important;
}

#showRateCardPrice .category .category-name {
  word-break: break-all;
}
.category {
  display: flex;
  flex-direction: column;
  /* width: 180px; */
  width: 160px;
  /* height: 160px; */
  height: 150px;
  background-color: #efefef;
  color: black;
  text-align: center;
  margin: 1rem;
  border-radius: 0.5rem;
}
.category.disabled {
  background-color: #f9f9f9;
  color: #999999;
}
.category.disabled .mod-btn {
  background-color: #afc8ed;
}
.category .category-name {
  /* font-size: 1.5rem; */
  font-size: 1.25rem;
  font-weight: 500;
  height: 53px;
  text-align: center;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.category .category-price {
  /* font-size: 1.5rem; */
  font-size: 1.25rem;
  font-weight: 500;
  height: 53px;
  text-align: center;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.category .category-seats {
  font-weight: bold;
  font-size: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-top: 1px solid #bfbfbf;
  padding: 0.25rem;
  width: 100%;
  color: black;
  user-select: none;
}
.category .category-seats .mod-btn {
  font-weight: bold;
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  color: white;
  background-color: #3876d2;
  height: 40px;
  width: 40px;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 0.4s;
}
.category .category-seats .mod-btn:hover {
  color: #3876d2;
  background-color: white;
}
.category .category-seats .mod-btn:active,
.category .category-seats .mod-btn.active {
  transform: scale(0.8);
}

.category .category-seats .mod-btn.disabled,
.btn-submit-disabled {
  background-color: lightgrey;
  pointer-events: none;
}

.fl.btn-blue {
  font-size: 20px !important;
  padding: 1.5rem 2rem;
}

.currency-symbol {
  position: absolute;
  top: 50%;
  right: 10px;
  font-size: 12px;
  transform: translateY(-50%);
}
.InputAmount {
  padding-right: 3rem !important;
}
.noFnbItem {
  font-size: 13px;
}
.no-fnb-btn {
  background-color: white !important;
  color: red !important;
  border-color: red !important;
}
.nfs-17 {
  font-size: 17px !important;
}
.disable_item {
  opacity: 0.4;
  pointer-events: none;
}
.ellipse{
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.btnDisable {
  opacity: 0.5;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/posFooter.vue